const Hamburger = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 7H23M2 16H23'
      stroke='#0F0F0F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const CloseIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.4'>
      <path
        d='M6 18L18 6M6 6L18 18'
        stroke='#0F0F0F'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
const UserIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z'
      stroke='#0F0F0F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowDown = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.16667 7.5L10 13.3333L15.8333 7.5'
      stroke='#0F0F0F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowUp = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.8334 12.5L10 6.66667L4.16669 12.5'
      stroke='#0F0F0F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const WhiteCheckMark = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 12.5C8 12.5 10 13 11.5 16C11.5 16 17.0588 6.83333 22 5'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CheckMark = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM12.0607 7.06066C12.6464 6.47487 12.6464 5.52513 12.0607 4.93934C11.4749 4.35355 10.5251 4.35355 9.93934 4.93934L7 7.87868L6.06066 6.93934C5.47487 6.35355 4.52513 6.35355 3.93934 6.93934C3.35355 7.52513 3.35355 8.47487 3.93934 9.06066L5.93934 11.0607C6.52513 11.6464 7.47487 11.6464 8.06066 11.0607L12.0607 7.06066Z'
      fill='black'
    />
    <path
      d='M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM12.0607 7.06066C12.6464 6.47487 12.6464 5.52513 12.0607 4.93934C11.4749 4.35355 10.5251 4.35355 9.93934 4.93934L7 7.87868L6.06066 6.93934C5.47487 6.35355 4.52513 6.35355 3.93934 6.93934C3.35355 7.52513 3.35355 8.47487 3.93934 9.06066L5.93934 11.0607C6.52513 11.6464 7.47487 11.6464 8.06066 11.0607L12.0607 7.06066Z'
      fill='#3FC1A2'
      fillOpacity='0.8'
    />
    <path
      d='M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM12.0607 7.06066C12.6464 6.47487 12.6464 5.52513 12.0607 4.93934C11.4749 4.35355 10.5251 4.35355 9.93934 4.93934L7 7.87868L6.06066 6.93934C5.47487 6.35355 4.52513 6.35355 3.93934 6.93934C3.35355 7.52513 3.35355 8.47487 3.93934 9.06066L5.93934 11.0607C6.52513 11.6464 7.47487 11.6464 8.06066 11.0607L12.0607 7.06066Z'
      stroke='#F5F2F1'
    />
  </svg>
);
const SearchIcon = () => (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.3195 16.3195L12.9392 12.9392M14.7653 8.54866C14.7653 11.982 11.982 14.7653 8.54866 14.7653C5.11531 14.7653 2.33203 11.982 2.33203 8.54866C2.33203 5.11531 5.11531 2.33203 8.54866 2.33203C11.982 2.33203 14.7653 5.11531 14.7653 8.54866Z'
      stroke='white'
      strokeWidth='1.14183'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const CheckMarkIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10'
      stroke='#195D9D'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M8 12.5C8 12.5 9.5 12.5 11.5 16C11.5 16 17.0588 6.83333 22 5'
      stroke='#195D9D'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const Treatment = () => (
  <svg
    width='49'
    height='48'
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='21.9282' cy='10.2856' r='7.71429' fill='#C5ECE3' />
    <path
      d='M13.7861 38.5718V34.7147L26.2147 34.2861V38.5718H13.7861Z'
      fill='#C5ECE3'
      stroke='black'
      strokeWidth='0.857143'
    />
    <path
      d='M21.7167 10.848C21.8607 11.04 22.1007 11.136 22.2927 11.136C22.4367 11.136 22.5807 11.088 22.7247 10.992C23.0607 10.752 23.1087 10.32 22.9167 9.98395L20.9007 7.15195C20.6607 6.81595 20.2287 6.76796 19.8927 6.95996C19.5567 7.19996 19.4607 7.67996 19.7007 7.96796L21.7167 10.848Z'
      fill='#0F0F0F'
    />
    <path
      d='M38.4207 26.7364L40.3407 13.5844C40.6767 11.3764 40.2927 9.55239 39.1887 8.25639C38.1807 7.10439 36.6927 6.48039 34.7727 6.48039H29.3007C27.9087 4.08039 25.3167 2.40039 22.2927 2.40039C19.2687 2.40039 16.6287 4.08039 15.2847 6.52839H9.7647C7.8927 6.52839 6.3567 7.15239 5.3487 8.30439C4.2447 9.55239 3.8607 11.3764 4.1967 13.6324L7.9887 39.4084C8.3727 42.0004 10.2447 43.5364 13.0287 43.5364H29.2047C30.8367 44.8324 32.9007 45.6004 35.1567 45.6004C40.5327 45.6004 44.8527 41.2324 44.8527 35.9044C44.9007 31.6804 42.1647 28.0804 38.4207 26.7364ZM22.2927 3.84039C25.8927 3.84039 28.8687 6.76839 28.8687 10.4164C28.8687 14.0644 25.9407 16.9924 22.2927 16.9924C18.6447 16.9924 15.7167 14.0644 15.7167 10.4164C15.7167 6.76839 18.6447 3.84039 22.2927 3.84039ZM9.4287 39.1684L5.6367 13.3924C5.3487 11.6164 5.6367 10.1764 6.4527 9.21639C7.1727 8.40039 8.3247 7.96839 9.7647 7.96839H14.6127C14.3727 8.73639 14.2287 9.55239 14.2287 10.4164C14.2287 14.8324 17.8287 18.4324 22.2447 18.4324C26.6607 18.4324 30.2607 14.8324 30.2607 10.4164C30.2607 9.55239 30.1167 8.73639 29.8767 7.96839H34.7247C36.1647 7.96839 37.3167 8.40039 38.0367 9.21639C38.8527 10.1284 39.1407 11.5684 38.8527 13.3924L36.9327 26.3524C36.3567 26.2564 35.7327 26.1604 35.1087 26.1604C30.5487 26.1604 26.7567 29.2804 25.7007 33.5044H13.7007C13.3167 33.5044 12.9807 33.8404 12.9807 34.2244V38.4004C12.9807 38.7844 13.3167 39.1204 13.7007 39.1204H25.9887C26.3727 40.2244 26.9487 41.2324 27.6687 42.0964H13.0287C11.0127 42.0964 9.7167 41.0884 9.4287 39.1684ZM25.6527 37.6804H14.4687V34.9924H25.5087C25.4607 35.2804 25.4607 35.5684 25.4607 35.9044C25.4607 36.5284 25.5567 37.1044 25.6527 37.6804ZM35.2047 44.1604C30.6447 44.1604 26.9007 40.4644 26.9007 35.9044C26.9007 31.3444 30.5967 27.6484 35.1567 27.6484C39.7167 27.6484 43.4127 31.3444 43.4127 35.9044C43.4607 40.4644 39.7647 44.1604 35.2047 44.1604Z'
      fill='#0F0F0F'
    />
    <path
      d='M37.8448 36.5764L35.9248 38.4964V31.5364C35.9248 31.1524 35.5888 30.8164 35.2048 30.8164C34.8208 30.8164 34.4848 31.1524 34.4848 31.5364V38.4964L32.5648 36.5764C32.2768 36.2884 31.8448 36.2884 31.5568 36.5764C31.2688 36.8644 31.2688 37.2964 31.5568 37.5844L34.7248 40.7524C34.8688 40.8964 35.0608 40.9444 35.2528 40.9444C35.4448 40.9444 35.6368 40.8964 35.7808 40.7524L38.9488 37.5844C39.2368 37.2964 39.2368 36.8644 38.9488 36.5764C38.5648 36.2884 38.1328 36.2884 37.8448 36.5764Z'
      fill='#0F0F0F'
    />
  </svg>
);
const Dosage = () => (
  <svg
    width='49'
    height='48'
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.46345 8.57129H11.6063L12.4634 11.5713L13.7492 12.4284L15.892 10.7141V8.57129H33.0349V10.7141L35.1777 12.4284L36.892 11.1427V8.57129H41.6063L43.3206 9.857V16.7141H5.17773L5.60631 9.857L6.46345 8.57129Z'
      fill='#C5ECE3'
    />
    <path
      d='M7.75443 7.85368V7.85376H10.6317H10.8386L10.8385 7.85393H11.1712V5.93029C11.1712 4.5035 12.3317 3.343 13.7587 3.343C15.1858 3.343 16.3463 4.5035 16.3463 5.93029V7.85393H32.326V5.93029C32.326 4.5035 33.4865 3.343 34.9135 3.343C36.3405 3.343 37.5011 4.5035 37.5011 5.93029V7.85385H41.0037C42.6458 7.85385 44.0081 9.19802 44.0081 10.8583V10.8764V10.8951V10.9142V10.9338V10.9539V10.9745V10.9956V11.0172V11.0392V11.0617V11.0847V11.1081V11.132V11.1564V11.1813V11.2066V11.2324V11.2586V11.2853V11.3125V11.3401V11.3681V11.3967V11.4256V11.455V11.4849V11.5152V11.5459V11.5771V11.6087V11.6408V11.6733V11.7062V11.7395V11.7733V11.8075V11.8422V11.8772V11.9127V11.9486V11.9849V12.0216V12.0587V12.0963V12.1342V12.1726V12.2114V12.2505V12.2901V12.3301V12.3705V12.4112V12.4524V12.4939V12.5359V12.5782V12.6209V12.664V12.7075V12.7514V12.7956V12.8402V12.8852V12.9306V12.9763V13.0224V13.0689V13.1157V13.1629V13.2105V13.2584V13.3067V13.3553V13.4043V13.4537V13.5033V13.5534V13.6038V13.6545V13.7056V13.757V13.8087V13.8608V13.9133V13.966V14.0191V14.0725V14.1263V14.1803V14.2347V14.2894V14.3445V14.3998V14.4555V14.5115V14.5678V14.6244V14.6813V14.7385V14.796V14.8538V14.912V14.9704V15.0291V15.0881V15.1474V15.207V15.2669V15.3271V15.3875V15.4483V15.5093V15.5706V15.6322V15.694V15.7562V15.8186V15.8813V15.9442V16.0074V16.0709V16.1346V16.1986V16.2629V16.3274V16.3921V16.4572V16.5224V16.5879V16.6537V16.7197V16.786V16.8525V16.9192V16.9862V17.0534V17.1208V17.1885V17.2564V17.3245V17.3929V17.4615V17.5303V17.5993V17.6686V17.738V17.8077V17.8776V17.9477V18.018V18.0885V18.1592V18.2302V18.3013V18.3726V18.4441V18.5158V18.5878V18.6599V18.7322V18.8046V18.8773V18.9502V19.0232V19.0964V19.1698V19.2434V19.3171V19.3911V19.4651V19.5394V19.6138V19.6884V19.7632V19.8381V19.9132V19.9884V20.0638V20.1394V20.215V20.2909V20.3669V20.443V20.5193V20.5957V20.6723V20.749V20.8259V20.9028V20.98V21.0572V21.1346V21.2121V21.2897V21.3674V21.4453V21.5233V21.6014V21.6796V21.758V21.8364V21.915V21.9936V22.0724V22.1513V22.2303V22.3093V22.3885V22.4678V22.5472V22.6266V22.7062V22.7858V22.8656V22.9454V23.0253V23.1052V23.1853V23.2654V23.3457V23.4259V23.5063V23.5867V23.6672V23.7478V23.8284V23.9091V23.9899V24.0707V24.1515V24.2325V24.3134V24.3945V24.4755V24.5567V24.6378V24.719V24.8003V24.8816V24.9629V25.0443V25.1257V25.2071V25.2886V25.3701V25.4516V25.5331V25.6147V25.6963V25.7779V25.8595V25.9411V26.0228V26.1044V26.1861V26.2678V26.3494V26.4311V26.5128V26.5945V26.6762V26.7578V26.8395V26.9212V27.0028V27.0845V27.1661V27.2477V27.3293V27.4109V27.4924V27.574V27.6555V27.7369V27.8184V27.8998V27.9812V28.0625V28.1439V28.2251V28.3064V28.3876V28.4687V28.5498V28.6309V28.7119V28.7928V28.8737V28.9546V29.0353V29.1161V29.1967V29.2773V29.3579V29.4383V29.5187V29.5991V29.6793V29.7595V29.8396V29.9196V29.9996V30.0795V30.1592V30.2389V30.3185V30.3981V30.4775V30.5568V30.636V30.7152V30.7942V30.8732V30.952V31.0307V31.1093V31.1879V31.2663V31.3445V31.4227V31.5008V31.5787V31.6565V31.7342V31.8118V31.8892V31.9666V32.0438V32.1208V32.1977V32.2745V32.3512V32.4277V32.504V32.5803V32.6564V32.7323V32.8081V32.8837V32.9592V33.0345V33.1097V33.1847V33.2595V33.3342V33.4088V33.4831V33.5573V33.6313V33.7052V33.7788V33.8523V33.9257V33.9988V34.0718V34.1446V34.2171V34.2895V34.3618V34.4338V34.5056V34.5773V34.6487V34.7199V34.791V34.8618V34.9325V35.0029V35.0731V35.1431V35.2129V35.2825V35.3519V35.421V35.49V35.5587V35.6272V35.6954V35.7635V35.8313V35.8989V35.9662V36.0333V36.1002V36.1668V36.2332V36.2994V36.3653V36.431V36.4964V36.5615V36.6264V36.6911V36.7555V36.8197V36.8835V36.9472V37.0105V37.0736V37.1365V37.199V37.2613V37.3233V37.3851V37.4465V37.5077V37.5686V37.6293V37.6896V37.7497V37.8094V37.8689V37.9281V37.987V38.0456V38.1039V38.1619V38.2196V38.277V38.334V38.3908V38.4473V38.5035V38.5593V38.6149V38.6701V38.725V38.7796V38.8338V38.8877V38.9413V38.9946V39.0476V39.1002V39.1525V39.2044V39.256V39.3073V39.3582V39.4088V39.4591V39.509V39.5585V39.6077V39.6566V39.705V39.7532V39.8009V39.8484V39.8954V39.9421V39.9884V40.0344V40.0799V40.1252V40.17V40.2145V40.2585V40.3022V40.3456V40.3885V40.4311V40.4732V40.515V40.5564V40.5974V40.638V40.6782V40.718V40.7574V40.7964V40.835V40.8732V40.911V40.9484V40.9853V41.0219V41.058V41.0937V41.129V41.1639V41.1983V41.2324V41.266V41.2991V41.3319V41.3642V41.3961V41.4275V41.4585V41.4891V41.5192V41.5488V41.5781V41.6068V41.6352V41.6631V41.6905V41.7174V41.7439V41.77V41.7956V41.8207V41.8454V41.8696V41.8933V41.9165V41.9393V41.9616V41.9835V42.0048V42.0257C44.0081 43.6825 42.6605 45.0303 41.0037 45.0303H7.66872C6.0119 45.0303 4.66429 43.6825 4.66429 42.0257V10.8583C4.66429 10.6513 4.68533 10.449 4.72546 10.2536L7.75443 7.85368ZM7.75443 7.85368H7.66872M7.75443 7.85368H7.66872M7.66872 7.85368C6.21883 7.85368 5.00609 8.8857 4.72546 10.2535L7.66872 7.85368ZM41.0037 43.8463H7.66872C6.66513 43.8463 5.84835 43.0295 5.84835 42.0257V17.5503H42.8241V42.0257C42.8241 43.0295 42.0073 43.8463 41.0037 43.8463ZM33.51 5.93029C33.51 5.15649 34.1397 4.52697 34.9135 4.52697C35.6873 4.52697 36.317 5.15649 36.317 5.93029V10.2128C36.317 10.9866 35.6873 11.6163 34.9135 11.6163C34.1397 11.6163 33.51 10.9866 33.51 10.2128V5.93029ZM12.3553 5.93029C12.3553 5.15649 12.985 4.52697 13.7588 4.52697C14.5326 4.52697 15.1623 5.15649 15.1623 5.93029V10.2128C15.1623 10.9866 14.5326 11.6163 13.7588 11.6163C12.985 11.6163 12.3553 10.9866 12.3553 10.2128V5.93029ZM13.7589 12.8003C15.1859 12.8003 16.3465 11.6397 16.3465 10.2128V9.03791H32.3262V10.2128C32.3262 11.6396 33.4867 12.8003 34.9137 12.8003C36.3407 12.8003 37.5012 11.6396 37.5012 10.2128V9.03791H41.0039C41.9681 9.03791 42.8243 9.84794 42.8243 10.8583V16.3663H5.84835V10.8583C5.84835 9.85469 6.66513 9.03791 7.66872 9.03791H11.1714V10.2128C11.1714 11.6396 12.3319 12.8003 13.7589 12.8003Z'
      fill='none'
      stroke='#0F0F0F'
      strokeWidth='0.171429'
    />
    <path
      d='M23.6755 23.6263L23.6755 23.6263C25.5353 21.7664 28.5624 21.7664 30.4221 23.6264L30.4221 23.6264C32.2819 25.4861 32.2819 28.5131 30.4221 30.3729L24.4221 36.3729L24.4221 36.3729C23.4924 37.3027 22.2715 37.7677 21.0488 37.7677C19.8262 37.7677 18.6052 37.3027 17.6756 36.3729L17.6755 36.3729C16.774 35.4713 16.2783 34.2745 16.2783 32.9996C16.2783 31.7247 16.774 30.5278 17.6755 29.6263L23.6755 23.6263ZM22.9789 34.9296L22.9789 34.9296L24.9846 32.9238L25.2573 32.6511L24.9846 32.3784L21.67 29.0638L21.3973 28.7911L21.1246 29.0638L19.1189 31.0695L19.1188 31.0695C18.6039 31.5845 18.3195 32.2712 18.3195 32.9996C18.3195 33.7279 18.6038 34.4146 19.1189 34.9296C20.1834 35.9941 21.9144 35.9941 22.9789 34.9296ZM28.9789 28.9296L28.9789 28.9296C30.0433 27.8651 30.0433 26.134 28.979 25.0696L28.979 25.0696C28.4466 24.5372 27.747 24.2712 27.0489 24.2712C26.3509 24.2712 25.6513 24.5372 25.1189 25.0696L23.1132 27.0753L22.8404 27.348L23.1132 27.6208L26.4277 30.9353L26.7005 31.2081L26.9732 30.9353L28.9789 28.9296Z'
      fill='black'
      stroke='#F5F5F5'
      strokeWidth='0.771429'
    />
  </svg>
);
const Lisence = () => (
  <svg
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M31.7298 22.2086L31.7299 22.2088L31.7391 22.2057C31.8134 22.1809 31.9053 22.1702 31.9986 22.1702C38.5644 22.1702 43.9154 27.5212 43.9154 34.087V42.8766C43.9154 44.6093 42.6249 46.0567 40.9177 46.2489C29.3472 47.5372 17.6064 47.5371 6.04809 46.2488C4.3284 46.0565 3.03839 44.6088 3.03839 42.8766V34.087C3.03839 27.5212 8.38935 22.1702 14.9552 22.1702C14.9754 22.1702 15.0248 22.1758 15.118 22.195C15.2063 22.2132 15.3182 22.2402 15.4556 22.2749C15.5441 22.2972 15.6429 22.3226 15.7512 22.3506C15.9748 22.4083 16.2391 22.4764 16.5369 22.5489C17.4257 22.7652 18.6359 23.0259 20.1124 23.2017C23.0657 23.5534 27.0824 23.5654 31.7298 22.2086ZM6.2567 44.3371L6.25897 44.3374L40.6921 44.3376C40.6925 44.3376 40.693 44.3376 40.6934 44.3375C41.4374 44.2624 41.9949 43.6245 41.9949 42.8766V42.8644V34.0748C41.9949 28.9766 38.1715 24.7659 33.2478 24.1536L32.9589 24.1176V24.4087V31.7618V31.9713L33.1641 32.0136C35.8233 32.5618 37.8285 34.9182 37.8285 37.727V40.1618C37.8285 40.6893 37.3958 41.122 36.8682 41.122H35.6508C35.3198 41.122 35.0899 40.9993 34.9399 40.8289C34.7856 40.6535 34.7027 40.412 34.7027 40.1618C34.7027 39.9115 34.7856 39.67 34.9399 39.4947C35.0899 39.3243 35.3198 39.2015 35.6508 39.2015H35.908V38.9444V37.727C35.908 35.5763 34.1494 33.8177 31.9986 33.8177C29.8479 33.8177 28.0893 35.5763 28.0893 37.727V38.9444V39.2015H28.3465C28.6775 39.2015 28.9074 39.3243 29.0573 39.4947C29.2116 39.67 29.2945 39.9115 29.2945 40.1618C29.2945 40.412 29.2116 40.6535 29.0573 40.8289C28.9074 40.9993 28.6775 41.122 28.3465 41.122H27.1291C26.6015 41.122 26.1688 40.6893 26.1688 40.1618V37.727C26.1688 34.9055 28.1743 32.5501 30.8321 32.0138L31.0384 31.9722V31.7618V24.6766V24.351L30.7217 24.4264C25.9522 25.5614 21.0016 25.5614 16.2321 24.4264L15.9154 24.351V24.6766V29.4244V29.6048L16.085 29.6662C17.4015 30.1428 18.3502 31.3894 18.3502 32.8574C18.3502 34.7241 16.8218 36.2525 14.9552 36.2525C13.0885 36.2525 11.5601 34.7241 11.5601 32.8574C11.5601 31.3764 12.5095 30.1313 13.8235 29.6668L13.9949 29.6062V29.4244V24.4087V24.1169L13.7054 24.1536C8.78254 24.7784 4.95889 28.9884 4.95889 34.0748V42.8644C4.95889 43.6276 5.5188 44.2485 6.2567 44.3371ZM16.4297 32.8696C16.4297 32.058 15.7667 31.3951 14.9552 31.3951C14.1436 31.3951 13.4806 32.058 13.4806 32.8696C13.4806 33.6812 14.1436 34.3441 14.9552 34.3441C15.7667 34.3441 16.4297 33.6812 16.4297 32.8696Z'
      fill='black'
      stroke='#F5F5F5'
      strokeWidth='0.514286'
    />
    <path
      d='M23.3327 0.857143C28.8207 0.857143 33.287 5.32329 33.287 10.8112C33.287 16.2992 28.8209 20.7655 23.3327 20.7655C17.8446 20.7655 13.3786 16.2992 13.3786 10.8112C13.3786 5.32327 17.8448 0.857143 23.3327 0.857143ZM16.4676 10.8112C16.4676 14.5974 19.5465 17.6765 23.3327 17.6765C27.1189 17.6765 30.198 14.5975 30.198 10.8112C30.198 7.025 27.1189 3.94615 23.3327 3.94615C19.5465 3.94615 16.4676 7.02503 16.4676 10.8112Z'
      fill='black'
      stroke='#F5F5F5'
      strokeWidth='1.71429'
    />
    <circle cx='23.2809' cy='10.7594' r='7.62857' fill='#C5ECE3' />
  </svg>
);
const Shipping = () => (
  <svg
    width='49'
    height='48'
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M37.18 9.42857L31.18 6L11.4657 17.5714L11.0371 25.7143H14.4657L17.0371 28.2857L17.4657 20.1429L37.18 9.42857Z'
      fill='#C5ECE3'
    />
    <path
      d='M46.0853 12.8291L25.0853 2.3291C24.9812 2.27708 24.8664 2.25 24.75 2.25C24.6336 2.25 24.5189 2.27708 24.4148 2.3291L3.41476 12.8291C3.29009 12.8914 3.18524 12.9872 3.11198 13.1058C3.03872 13.2243 2.99995 13.361 3.00001 13.5004V34.5004C2.99925 34.6404 3.03769 34.7778 3.11099 34.8971C3.18429 35.0164 3.28951 35.1128 3.41476 35.1754L24.4148 45.6754C24.5189 45.7274 24.6336 45.7545 24.75 45.7545C24.8664 45.7545 24.9812 45.7274 25.0853 45.6754L46.0853 35.1754C46.2105 35.1128 46.3157 35.0164 46.389 34.8971C46.4623 34.7778 46.5008 34.6404 46.5 34.5004V13.5004C46.5001 13.361 46.4613 13.2243 46.388 13.1058C46.3148 12.9872 46.2099 12.8914 46.0853 12.8291ZM24.75 23.1618L18.8873 20.2301L37.6268 10.2754L44.0768 13.5004L24.75 23.1618ZM12.8873 17.2301L31.6268 7.27535L35.9768 9.45035L17.2395 19.4066L12.8873 17.2301ZM12 18.4639L16.5 20.7139V26.6898L14.7803 24.9701C14.6396 24.8294 14.4489 24.7504 14.25 24.7504H12V18.4639ZM24.75 3.83885L29.979 6.45035L11.2395 16.4066L5.42701 13.5004L24.75 3.83885ZM4.50001 14.7139L10.5 17.7139V25.5004C10.5 25.6993 10.579 25.89 10.7197 26.0307C10.8603 26.1713 11.0511 26.2504 11.25 26.2504H13.9395L16.7198 29.0306C16.8246 29.1355 16.9583 29.2069 17.1037 29.2358C17.2492 29.2647 17.4 29.2499 17.537 29.1931C17.674 29.1364 17.7911 29.0403 17.8736 28.9169C17.956 28.7936 18 28.6487 18 28.5004V21.4639L24 24.4639V43.7869L4.50001 34.0369V14.7139ZM25.5 43.7869V24.4639L45 14.7139V34.0369L25.5 43.7869Z'
      fill='black'
    />
  </svg>
);
const Fees = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16551_5502)'>
      <path
        d='M9.5 17C7.36312 17 5.35413 16.1679 3.84313 14.6569C2.33213 13.1459 1.5 11.1369 1.5 9C1.5 6.86312 2.33216 4.85416 3.84313 3.34313C5.35409 1.83209 7.36312 1 9.5 1C11.6369 1 13.6459 1.83213 15.1569 3.34313C16.6679 4.85413 17.5 6.86312 17.5 9C17.5 11.1369 16.6678 13.1458 15.1569 14.6569C13.6459 16.1679 11.6369 17 9.5 17ZM9.5 2C5.64019 2 2.5 5.14019 2.5 9C2.5 12.8598 5.64019 16 9.5 16C13.3598 16 16.5 12.8598 16.5 9C16.5 5.14019 13.3598 2 9.5 2Z'
        fill='white'
      />
      <path
        d='M9.5 8.5C8.81075 8.5 8.25 7.93925 8.25 7.25C8.25 6.56075 8.81075 6 9.5 6C10.1892 6 10.75 6.56075 10.75 7.25C10.75 7.52612 10.9738 7.75 11.25 7.75C11.5262 7.75 11.75 7.52612 11.75 7.25C11.75 6.18122 11.0007 5.28475 10 5.05669V4.5C10 4.22387 9.77616 4 9.5 4C9.22384 4 9 4.22387 9 4.5V5.05669C7.99931 5.28475 7.25 6.18122 7.25 7.25C7.25 8.49066 8.25934 9.5 9.5 9.5C10.1892 9.5 10.75 10.0608 10.75 10.75C10.75 11.4392 10.1892 12 9.5 12C8.81075 12 8.25 11.4392 8.25 10.75C8.25 10.4739 8.02616 10.25 7.75 10.25C7.47384 10.25 7.25 10.4739 7.25 10.75C7.25 11.8188 7.99931 12.7153 9 12.9433V13.5C9 13.7761 9.22384 14 9.5 14C9.77616 14 10 13.7761 10 13.5V12.9433C11.0007 12.7153 11.75 11.8188 11.75 10.75C11.75 9.50934 10.7407 8.5 9.5 8.5Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_16551_5502'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(1.5 1)'
        />
      </clipPath>
    </defs>
  </svg>
);
const OnlineCare = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16551_5509)'>
      <path
        d='M18.2557 13.9197L16.8417 12.0203V4.04531C16.8417 2.97999 15.975 2.11328 14.9097 2.11328H4.09034C3.02502 2.11328 2.15832 2.97999 2.15832 4.04531V12.0203L0.744322 13.9197C0.465021 14.2949 0.421919 14.7877 0.631878 15.2057C0.841801 15.6236 1.26281 15.8833 1.73053 15.8833H17.2694C17.7372 15.8833 18.1582 15.6237 18.3681 15.2057C18.5781 14.7877 18.535 14.2949 18.2557 13.9197ZM3.21215 4.04531C3.21215 3.56107 3.60611 3.16711 4.09034 3.16711H14.9097C15.3939 3.16711 15.7879 3.56107 15.7879 4.04531V11.668H3.21215V4.04531ZM17.4264 14.7327C17.4083 14.7688 17.3638 14.8295 17.2695 14.8295H1.73053C1.63625 14.8295 1.59174 14.7688 1.57358 14.7327C1.55539 14.6966 1.53332 14.6246 1.58963 14.549L2.94985 12.7218H16.0502L17.4104 14.549C17.4667 14.6246 17.4446 14.6966 17.4264 14.7327Z'
        fill='white'
      />
      <path
        d='M10.9386 4.22266H8.05817C7.76717 4.22266 7.53125 4.45857 7.53125 4.74957C7.53125 5.04057 7.76717 5.27649 8.05817 5.27649H10.9386C11.2296 5.27649 11.4656 5.04057 11.4656 4.74957C11.4656 4.45857 11.2296 4.22266 10.9386 4.22266Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_16551_5509'>
        <rect width='18' height='18' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);
const Secure = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 16C9.28616 15.9998 9.07593 15.9493 8.88932 15.8531L6.46975 14.615C5.26695 13.9989 4.26472 13.098 3.56678 12.0053C2.86884 10.9127 2.50054 9.66816 2.5 8.40043V4.96429C2.49979 4.6782 2.61484 4.40223 2.82285 4.1898C3.03087 3.97736 3.31705 3.84359 3.626 3.81437C4.58855 3.72045 5.53588 3.52321 6.44872 3.22669C7.2857 2.95421 8.08862 2.59999 8.84375 2.1701C9.04134 2.05881 9.26845 1.99994 9.50005 2C9.73165 2.00006 9.95873 2.05903 10.1562 2.17042C10.9115 2.60009 11.7144 2.95418 12.5513 3.22669C13.4641 3.52322 14.4115 3.72046 15.374 3.81439C15.6829 3.84361 15.9691 3.97738 16.1771 4.18981C16.3852 4.40224 16.5002 4.67821 16.5 4.96429V8.40045C16.4995 9.66818 16.1312 10.9127 15.4332 12.0054C14.7353 13.098 13.7331 13.9989 12.5302 14.615L10.11 15.8534C9.92356 15.9494 9.71357 15.9999 9.5 16ZM9.5 2.99093C9.46836 2.9908 9.4373 2.99874 9.41026 3.01386C8.58958 3.48069 7.71711 3.86574 6.80769 4.16181C5.81556 4.48431 4.78585 4.69868 3.73958 4.80054C3.69513 4.8041 3.65374 4.8229 3.62362 4.85322C3.59349 4.88354 3.57683 4.92318 3.57692 4.96429V8.40045C3.57735 9.49127 3.89424 10.5622 4.49481 11.5023C5.09538 12.4424 5.95779 13.2176 6.99279 13.7477L9.41306 14.986C9.43949 14.9997 9.46928 15.007 9.49961 15.007C9.52993 15.0071 9.55976 15 9.58624 14.9864L12.0072 13.7477C13.0422 13.2176 13.9046 12.4424 14.5052 11.5023C15.1058 10.5622 15.4227 9.49127 15.4231 8.40045V4.96429C15.4232 4.92319 15.4065 4.88355 15.3764 4.85323C15.3463 4.82291 15.3049 4.80412 15.2604 4.80056C14.2142 4.6987 13.1844 4.48432 12.1923 4.16181C11.2829 3.86573 10.4104 3.481 9.58974 3.01416C9.5628 2.9988 9.53169 2.99075 9.5 2.99093Z'
      fill='white'
    />
    <path
      d='M8.75 8.35H8.85V8.25V6.85H10.15V8.25V8.35H10.25H11.65V9.65H10.25H10.15V9.75V11.15H8.85V9.75V9.65H8.75H7.35V8.35H8.75Z'
      fill='white'
      stroke='black'
      strokeWidth='0.2'
    />
  </svg>
);
const Insurance = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 16C9.28616 15.9998 9.07593 15.9493 8.88932 15.8531L6.46975 14.615C5.26695 13.9989 4.26472 13.098 3.56678 12.0053C2.86884 10.9127 2.50054 9.66816 2.5 8.40043V4.96429C2.49979 4.6782 2.61484 4.40223 2.82285 4.1898C3.03087 3.97736 3.31705 3.84359 3.626 3.81437C4.58855 3.72045 5.53588 3.52321 6.44872 3.22669C7.2857 2.95421 8.08862 2.59999 8.84375 2.1701C9.04134 2.05881 9.26845 1.99994 9.50005 2C9.73165 2.00006 9.95873 2.05903 10.1562 2.17042C10.9115 2.60009 11.7144 2.95418 12.5513 3.22669C13.4641 3.52322 14.4115 3.72046 15.374 3.81439C15.6829 3.84361 15.9691 3.97738 16.1771 4.18981C16.3852 4.40224 16.5002 4.67821 16.5 4.96429V8.40045C16.4995 9.66818 16.1312 10.9127 15.4332 12.0054C14.7353 13.098 13.7331 13.9989 12.5302 14.615L10.11 15.8534C9.92356 15.9494 9.71357 15.9999 9.5 16ZM9.5 2.99093C9.46836 2.9908 9.4373 2.99874 9.41026 3.01386C8.58958 3.48069 7.71711 3.86574 6.80769 4.16181C5.81556 4.48431 4.78585 4.69868 3.73958 4.80054C3.69513 4.8041 3.65374 4.8229 3.62362 4.85322C3.59349 4.88354 3.57683 4.92318 3.57692 4.96429V8.40045C3.57735 9.49127 3.89424 10.5622 4.49481 11.5023C5.09538 12.4424 5.95779 13.2176 6.99279 13.7477L9.41306 14.986C9.43949 14.9997 9.46928 15.007 9.49961 15.007C9.52993 15.0071 9.55976 15 9.58624 14.9864L12.0072 13.7477C13.0422 13.2176 13.9046 12.4424 14.5052 11.5023C15.1058 10.5622 15.4227 9.49127 15.4231 8.40045V4.96429C15.4232 4.92319 15.4065 4.88355 15.3764 4.85323C15.3463 4.82291 15.3049 4.80412 15.2604 4.80056C14.2142 4.6987 13.1844 4.48432 12.1923 4.16181C11.2829 3.86573 10.4104 3.481 9.58974 3.01416C9.5628 2.9988 9.53169 2.99075 9.5 2.99093Z'
      fill='white'
    />
    <path
      d='M8.99767 11C8.8753 11.0002 8.75715 10.9512 8.66585 10.8624L7.16667 9.40949C7.06806 9.3134 7.00843 9.1786 7.00083 9.03465C6.99323 8.8907 7.03829 8.74933 7.12613 8.64154C7.21397 8.53375 7.33743 8.46833 7.46944 8.45962C7.60145 8.45091 7.73125 8.49962 7.83037 8.59507L8.96582 9.69538L11.132 7.17659C11.1766 7.12347 11.2306 7.08055 11.2906 7.0503C11.3506 7.02005 11.4155 7.00309 11.4815 7.00038C11.5476 6.99768 11.6135 7.00929 11.6754 7.03455C11.7373 7.05981 11.794 7.09821 11.8422 7.14753C11.8904 7.19685 11.9292 7.25611 11.9562 7.32187C11.9833 7.38764 11.9981 7.4586 11.9998 7.53065C12.0016 7.6027 11.9901 7.6744 11.9663 7.74161C11.9424 7.80882 11.9065 7.8702 11.8607 7.92219L9.3621 10.828C9.31543 10.8824 9.259 10.9257 9.1963 10.9553C9.1336 10.9849 9.06599 11.0001 8.99767 11Z'
      fill='white'
    />
  </svg>
);
const Heart = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.3544 7.70652V5.63563C14.3544 4.54831 14.3544 4.00465 14.1428 3.58935C13.9567 3.22404 13.6597 2.92704 13.2944 2.7409C12.8791 2.5293 12.3354 2.5293 11.2481 2.5293H7.10633C6.01901 2.5293 5.47536 2.5293 5.06005 2.7409C4.69475 2.92704 4.39774 3.22404 4.21161 3.58935C4 4.00465 4 4.54831 4 5.63563V12.366C4 13.4533 4 13.997 4.21161 14.4123C4.39774 14.7776 4.69475 15.0746 5.06005 15.2607C5.47536 15.4724 6.01901 15.4724 7.10633 15.4724H9.17722M9.5008 8.35367H6.58861M7.23576 10.9423H6.58861M11.7658 5.76506H6.58861M12.4112 10.8327C11.8937 10.2444 11.0306 10.0862 10.3821 10.6248C9.73368 11.1635 9.64239 12.0641 10.1516 12.7012C10.6609 13.3383 12.4112 14.8252 12.4112 14.8252C12.4112 14.8252 14.1616 13.3383 14.6708 12.7012C15.18 12.0641 15.0999 11.1578 14.4403 10.6248C13.7807 10.0918 12.9288 10.2444 12.4112 10.8327Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const CheckVerified = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_2603_4160)'>
      <path
        d='M11.9342 3.33201C12.0714 3.66403 12.3349 3.92794 12.6667 4.06572L13.8302 4.54766C14.1622 4.6852 14.426 4.949 14.5636 5.28105C14.7011 5.61309 14.7011 5.98617 14.5636 6.31821L14.082 7.48088C13.9444 7.81307 13.9442 8.18652 14.0824 8.51855L14.5632 9.68087C14.6313 9.84533 14.6664 10.0216 14.6665 10.1996C14.6665 10.3777 14.6315 10.554 14.5633 10.7184C14.4952 10.8829 14.3953 11.0324 14.2694 11.1582C14.1435 11.2841 13.9941 11.3839 13.8296 11.452L12.6669 11.9336C12.3349 12.0709 12.071 12.3344 11.9333 12.6662L11.4513 13.8297C11.3138 14.1617 11.05 14.4255 10.718 14.5631C10.3859 14.7006 10.0129 14.7006 9.68085 14.5631L8.51823 14.0815C8.18619 13.9443 7.81326 13.9446 7.48142 14.0823L6.31797 14.5635C5.98612 14.7007 5.61338 14.7006 5.28162 14.5632C4.94986 14.4258 4.68621 14.1623 4.54858 13.8306L4.06652 12.6667C3.92924 12.3347 3.66574 12.0708 3.33394 11.933L2.17048 11.4511C1.8386 11.3136 1.57488 11.05 1.4373 10.7181C1.29971 10.3863 1.29953 10.0134 1.43678 9.68137L1.91835 8.51871C2.05554 8.18666 2.05526 7.81371 1.91757 7.48186L1.43669 6.31753C1.36851 6.15307 1.3334 5.97679 1.33337 5.79876C1.33335 5.62073 1.3684 5.44444 1.43652 5.27996C1.50465 5.11548 1.60452 4.96604 1.73042 4.84018C1.85632 4.71431 2.00579 4.61449 2.17028 4.54641L3.33291 4.06482C3.66462 3.92766 3.92836 3.66447 4.06624 3.33305L4.54816 2.16955C4.68569 1.8375 4.94949 1.5737 5.28152 1.43616C5.61355 1.29862 5.98662 1.29862 6.31865 1.43616L7.48127 1.91775C7.81331 2.05495 8.18624 2.05467 8.51808 1.91697L9.68202 1.43691C10.014 1.29945 10.387 1.29948 10.719 1.43699C11.0509 1.5745 11.3147 1.83823 11.4522 2.17018L11.9343 3.33403L11.9342 3.33201Z'
        fill='#3FC1A2'
        fillOpacity='0.3'
      />
      <path
        d='M6.00004 7.99967L7.33337 9.33301L10.3334 6.33301M11.9342 3.33201C12.0714 3.66403 12.3349 3.92794 12.6667 4.06572L13.8302 4.54766C14.1622 4.6852 14.426 4.949 14.5636 5.28105C14.7011 5.61309 14.7011 5.98617 14.5636 6.31821L14.082 7.48088C13.9444 7.81307 13.9442 8.18652 14.0824 8.51855L14.5632 9.68087C14.6313 9.84533 14.6664 10.0216 14.6665 10.1996C14.6665 10.3777 14.6315 10.554 14.5633 10.7184C14.4952 10.8829 14.3953 11.0324 14.2694 11.1582C14.1435 11.2841 13.9941 11.3839 13.8296 11.452L12.6669 11.9336C12.3349 12.0709 12.071 12.3344 11.9333 12.6662L11.4513 13.8297C11.3138 14.1617 11.05 14.4255 10.718 14.5631C10.3859 14.7006 10.0129 14.7006 9.68085 14.5631L8.51823 14.0815C8.18619 13.9443 7.81326 13.9446 7.48142 14.0823L6.31797 14.5635C5.98612 14.7007 5.61338 14.7006 5.28162 14.5632C4.94986 14.4258 4.68621 14.1623 4.54858 13.8306L4.06652 12.6667C3.92924 12.3347 3.66574 12.0708 3.33394 11.933L2.17048 11.4511C1.8386 11.3136 1.57488 11.05 1.4373 10.7181C1.29971 10.3863 1.29953 10.0134 1.43678 9.68137L1.91835 8.51871C2.05554 8.18666 2.05526 7.81371 1.91757 7.48186L1.43669 6.31753C1.36851 6.15307 1.3334 5.97679 1.33337 5.79876C1.33335 5.62073 1.3684 5.44444 1.43652 5.27996C1.50465 5.11548 1.60452 4.96604 1.73042 4.84018C1.85632 4.71431 2.00579 4.61449 2.17028 4.54641L3.33291 4.06482C3.66462 3.92766 3.92836 3.66447 4.06624 3.33305L4.54816 2.16955C4.68569 1.8375 4.94949 1.5737 5.28152 1.43616C5.61355 1.29862 5.98662 1.29862 6.31865 1.43616L7.48127 1.91775C7.81331 2.05495 8.18624 2.05467 8.51808 1.91697L9.68202 1.43691C10.014 1.29945 10.387 1.29948 10.719 1.43699C11.0509 1.5745 11.3147 1.83823 11.4522 2.17018L11.9343 3.33403L11.9342 3.33201Z'
        stroke='#3FC1A2'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_2603_4160'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const CheckHero = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21.3765 5.24813C21.6339 5.87067 22.1279 6.3655 22.7501 6.62384L24.9315 7.52747C25.5541 7.78535 26.0487 8.27999 26.3066 8.90257C26.5645 9.52515 26.5645 10.2247 26.3066 10.8473L25.4036 13.0273C25.1457 13.6501 25.1453 14.3503 25.4045 14.9729L26.3058 17.1522C26.4337 17.4606 26.4995 17.7911 26.4996 18.1249C26.4996 18.4587 26.4339 18.7893 26.3062 19.0977C26.1784 19.4061 25.9912 19.6863 25.7551 19.9223C25.519 20.1583 25.2388 20.3455 24.9304 20.4731L22.7504 21.3761C22.1279 21.6335 21.6331 22.1276 21.3748 22.7497L20.4712 24.9313C20.2133 25.5539 19.7187 26.0485 19.0961 26.3064C18.4736 26.5643 17.7741 26.5643 17.1515 26.3064L14.9716 25.4034C14.349 25.1462 13.6498 25.1467 13.0276 25.4049L10.8461 26.3072C10.2239 26.5645 9.52501 26.5643 8.90296 26.3066C8.28091 26.0489 7.78657 25.5549 7.52852 24.9329L6.62465 22.7507C6.36725 22.1282 5.87318 21.6334 5.25106 21.375L3.06958 20.4714C2.44729 20.2136 1.95282 19.7193 1.69485 19.0971C1.43689 18.4749 1.43654 17.7757 1.69388 17.1532L2.59683 14.9732C2.85407 14.3506 2.85354 13.6513 2.59537 13.0291L1.69372 10.846C1.56588 10.5376 1.50005 10.2071 1.5 9.87329C1.49995 9.53948 1.56567 9.20894 1.6934 8.90054C1.82114 8.59214 2.00839 8.31194 2.24446 8.07594C2.48053 7.83994 2.76078 7.65277 3.06921 7.52513L5.24912 6.62215C5.87109 6.36496 6.36561 5.8715 6.62413 5.25007L7.52773 3.06851C7.7856 2.44593 8.28022 1.95129 8.90278 1.69341C9.52534 1.43553 10.2248 1.43553 10.8474 1.69341L13.0273 2.59639C13.6499 2.85364 14.3491 2.85312 14.9713 2.59493L17.1537 1.69481C17.7762 1.43707 18.4755 1.43713 19.098 1.69496C19.7204 1.95279 20.215 2.44729 20.4729 3.0697L21.3767 5.25191L21.3765 5.24813Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
    />
    <path
      d='M10.25 14L12.75 16.5L18.375 10.875M21.3765 5.24813C21.6339 5.87067 22.1279 6.3655 22.7501 6.62384L24.9315 7.52747C25.5541 7.78535 26.0487 8.27999 26.3066 8.90257C26.5645 9.52515 26.5645 10.2247 26.3066 10.8473L25.4036 13.0273C25.1457 13.6501 25.1453 14.3503 25.4045 14.9729L26.3058 17.1522C26.4337 17.4606 26.4995 17.7911 26.4996 18.1249C26.4996 18.4587 26.4339 18.7893 26.3062 19.0977C26.1784 19.4061 25.9912 19.6863 25.7551 19.9223C25.519 20.1583 25.2388 20.3455 24.9304 20.4731L22.7504 21.3761C22.1279 21.6335 21.6331 22.1276 21.3748 22.7497L20.4712 24.9313C20.2133 25.5539 19.7187 26.0485 19.0961 26.3064C18.4736 26.5643 17.7741 26.5643 17.1515 26.3064L14.9716 25.4034C14.349 25.1462 13.6498 25.1467 13.0276 25.4049L10.8461 26.3072C10.2239 26.5645 9.52501 26.5643 8.90296 26.3066C8.28091 26.0489 7.78657 25.5549 7.52852 24.9329L6.62465 22.7507C6.36725 22.1282 5.87318 21.6334 5.25106 21.375L3.06958 20.4714C2.44729 20.2136 1.95282 19.7193 1.69485 19.0971C1.43689 18.4749 1.43654 17.7757 1.69388 17.1532L2.59683 14.9732C2.85407 14.3506 2.85354 13.6513 2.59537 13.0291L1.69372 10.846C1.56588 10.5376 1.50005 10.2071 1.5 9.87329C1.49995 9.53948 1.56567 9.20894 1.6934 8.90054C1.82114 8.59214 2.00839 8.31194 2.24446 8.07594C2.48053 7.83994 2.76078 7.65277 3.06921 7.52513L5.24912 6.62215C5.87109 6.36496 6.36561 5.8715 6.62413 5.25007L7.52773 3.06851C7.7856 2.44593 8.28022 1.95129 8.90278 1.69341C9.52534 1.43553 10.2248 1.43553 10.8474 1.69341L13.0273 2.59639C13.6499 2.85364 14.3491 2.85312 14.9713 2.59493L17.1537 1.69481C17.7762 1.43707 18.4755 1.43713 19.098 1.69496C19.7204 1.95279 20.215 2.44729 20.4729 3.0697L21.3767 5.25191L21.3765 5.24813Z'
      stroke='#0F0F0F'
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowRight = ({ width = '21', height = '20', stroke = '#0F0F0F' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.16663 4.16634L14 9.99967L8.16663 15.833'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const CheckService = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M29.8353 8.33052C30.1785 9.16056 30.8373 9.82034 31.6668 10.1648L34.5754 11.3696C35.4055 11.7135 36.065 12.373 36.4088 13.2031C36.7527 14.0332 36.7527 14.9659 36.4088 15.796L35.2049 18.7027C34.8609 19.5332 34.8604 20.4668 35.206 21.2969L36.4078 24.2027C36.5783 24.6138 36.666 25.0545 36.6661 25.4996C36.6662 25.9447 36.5786 26.3854 36.4083 26.7966C36.2379 27.2078 35.9883 27.5814 35.6735 27.8961C35.3588 28.2107 34.9851 28.4603 34.5738 28.6305L31.6673 29.8344C30.8373 30.1777 30.1775 30.8364 29.8331 31.666L28.6283 34.5747C28.2845 35.4048 27.625 36.0643 26.7949 36.4082C25.9648 36.752 25.0321 36.752 24.2021 36.4082L21.2955 35.2042C20.4654 34.8612 19.5331 34.8619 18.7035 35.2061L15.7949 36.4093C14.9652 36.7523 14.0334 36.752 13.204 36.4085C12.3746 36.0649 11.7155 35.4062 11.3714 34.5769L10.1662 31.6673C9.82304 30.8373 9.16428 30.1775 8.33479 29.8331L5.42615 28.6282C4.59643 28.2845 3.93713 27.6254 3.59318 26.7958C3.24922 25.9662 3.24875 25.0339 3.59188 24.2039L4.79581 21.2973C5.1388 20.4671 5.1381 19.5348 4.79387 18.7051L3.59166 15.7943C3.42121 15.3832 3.33345 14.9425 3.33337 14.4974C3.3333 14.0523 3.42093 13.6116 3.59125 13.2004C3.76156 12.7892 4.01123 12.4156 4.32599 12.1009C4.64074 11.7863 5.01441 11.5367 5.42565 11.3665L8.3322 10.1625C9.16149 9.81963 9.82085 9.16168 10.1655 8.3331L11.3703 5.42436C11.7142 4.59425 12.3737 3.93473 13.2037 3.59089C14.0338 3.24705 14.9665 3.24705 15.7966 3.59089L18.7031 4.79487C19.5332 5.13786 20.4655 5.13716 21.2951 4.79292L24.205 3.59276C25.035 3.24911 25.9674 3.24918 26.7973 3.59295C27.6273 3.93673 28.2867 4.59606 28.6305 5.42595L29.8357 8.33556L29.8353 8.33052Z'
      fill='url(#paint0_linear_2603_5408)'
    />
    <path
      d='M15 19.9997L18.3334 23.333L25.8334 15.833M29.8353 8.33052C30.1785 9.16056 30.8373 9.82034 31.6668 10.1648L34.5754 11.3696C35.4055 11.7135 36.065 12.373 36.4088 13.2031C36.7527 14.0332 36.7527 14.9659 36.4088 15.796L35.2049 18.7027C34.8609 19.5332 34.8604 20.4668 35.206 21.2969L36.4078 24.2027C36.5783 24.6138 36.6661 25.0545 36.6661 25.4996C36.6662 25.9447 36.5786 26.3854 36.4083 26.7966C36.2379 27.2078 35.9883 27.5814 35.6735 27.8961C35.3588 28.2107 34.9851 28.4603 34.5738 28.6305L31.6673 29.8344C30.8373 30.1777 30.1775 30.8364 29.8331 31.666L28.6283 34.5747C28.2845 35.4048 27.625 36.0643 26.7949 36.4082C25.9648 36.752 25.0321 36.752 24.2021 36.4082L21.2955 35.2042C20.4654 34.8612 19.5331 34.8619 18.7035 35.2061L15.7949 36.4093C14.9652 36.7523 14.0334 36.752 13.204 36.4085C12.3746 36.0649 11.7155 35.4062 11.3714 34.5769L10.1662 31.6673C9.82304 30.8373 9.16428 30.1775 8.33479 29.8331L5.42615 28.6282C4.59643 28.2845 3.93713 27.6254 3.59318 26.7958C3.24922 25.9662 3.24875 25.0339 3.59188 24.2039L4.79581 21.2973C5.1388 20.4671 5.1381 19.5348 4.79387 18.7051L3.59166 15.7943C3.42121 15.3832 3.33345 14.9425 3.33337 14.4974C3.3333 14.0523 3.42093 13.6116 3.59125 13.2004C3.76156 12.7892 4.01123 12.4156 4.32599 12.1009C4.64074 11.7863 5.01441 11.5367 5.42565 11.3665L8.3322 10.1625C9.16149 9.81963 9.82085 9.16168 10.1655 8.3331L11.3703 5.42436C11.7142 4.59425 12.3737 3.93473 13.2037 3.59089C14.0338 3.24705 14.9665 3.24705 15.7966 3.59089L18.7031 4.79487C19.5332 5.13786 20.4655 5.13716 21.2951 4.79292L24.205 3.59276C25.035 3.24911 25.9674 3.24918 26.7973 3.59295C27.6273 3.93673 28.2867 4.59606 28.6305 5.42595L29.8357 8.33556L29.8353 8.33052Z'
      stroke='white'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2603_5408'
        x1='3.33337'
        y1='19.9997'
        x2='36.6667'
        y2='19.9997'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#41C7A2' />
        <stop offset='1' stopColor='#195D9D' />
      </linearGradient>
    </defs>
  </svg>
);
const ArrowWhite = () => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='36' height='36' rx='18' fill='white' />
    <path
      d='M15.5 12.1663L21.3333 17.9997L15.5 23.833'
      stroke='#0F0F0F'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const CheckTable = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22.7 11.9998C22.7 17.9092 17.9095 22.6998 12 22.6998C6.0906 22.6998 1.30005 17.9092 1.30005 11.9998C1.30005 6.09036 6.0906 1.2998 12 1.2998C17.9095 1.2998 22.7 6.09036 22.7 11.9998ZM17.5435 10.5433C18.2855 9.80131 18.2855 8.59829 17.5435 7.8563C16.8015 7.1143 15.5985 7.1143 14.8565 7.8563L10.6 12.1128L9.14355 10.6563C8.40155 9.9143 7.19854 9.9143 6.45654 10.6563C5.71455 11.3983 5.71455 12.6013 6.45654 13.3433L9.25654 16.1433C9.99854 16.8853 11.2016 16.8853 11.9435 16.1433L17.5435 10.5433Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
      stroke='#0F0F0F'
    />
  </svg>
);
const ArrowGreen = () => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 4.66536L13.3333 10.4987L7.5 16.332'
      stroke='#3FC1A2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const UrgentCare = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_5003_1753)'>
      <path
        d='M9.94317 46.5283L9.396 50.9057H46.604V47.0754L43.8682 44.8867H12.1319L9.94317 46.5283Z'
        fill='#C5ECE3'
      />
      <path
        d='M42.9257 45.3847H13.0743C12.5454 45.3847 12.1167 44.956 12.1167 44.4271V26.2799C12.1167 22.0267 13.7972 18.0202 16.7688 15.0487C24.7433 7.07421 38.2554 9.74303 42.6346 20.0971C43.4632 22.0559 43.8832 24.1361 43.8832 26.2799V44.4271C43.8832 44.956 43.4545 45.3847 42.9257 45.3847ZM41.9681 43.4696V26.2799C41.9681 18.5778 35.7021 12.3118 28 12.3118C20.2979 12.3118 14.0318 18.5778 14.0318 26.2799V43.4696H41.9681Z'
        fill='black'
      />
      <path
        d='M46.6723 51.472C46.1435 51.472 45.7147 51.0433 45.7147 50.5144V48.3877C45.7147 46.7313 44.3673 45.3839 42.711 45.3839H13.2885C11.6323 45.3839 10.2848 46.7313 10.2848 48.3877V50.5144C10.2848 51.0433 9.85605 51.472 9.3272 51.472C8.79836 51.472 8.36963 51.0433 8.36963 50.5144V48.3877C8.36963 45.6754 10.5762 43.4688 13.2885 43.4688H42.7109C45.4232 43.4688 47.6298 45.6754 47.6298 48.3877V50.5144C47.6299 51.0432 47.2011 51.472 46.6723 51.472Z'
        fill='black'
      />
      <path
        d='M46.8595 52.0012H9.14027C8.67705 52.0012 8.30151 51.5112 8.30151 50.9069C8.30151 50.3025 8.67703 49.8125 9.14027 49.8125H46.8595C47.3228 49.8125 47.6983 50.3025 47.6983 50.9069C47.6983 51.5112 47.3228 52.0012 46.8595 52.0012Z'
        fill='black'
      />
      <path
        d='M28 7.32679C27.4712 7.32679 27.0425 6.89807 27.0425 6.36922V0.957567C27.0425 0.428727 27.4712 0 28 0C28.5289 0 28.9576 0.428712 28.9576 0.957567V6.36922C28.9576 6.89806 28.5289 7.32679 28 7.32679Z'
        fill='black'
      />
      <path
        d='M43.2167 13.6285C42.3712 13.6285 41.9347 12.5987 42.5396 11.9938L46.3662 8.16718C46.7401 7.79323 47.3464 7.79323 47.7204 8.16718C48.0944 8.54114 48.0944 9.14742 47.7204 9.52139L43.8938 13.348C43.7068 13.535 43.4617 13.6285 43.2167 13.6285Z'
        fill='black'
      />
      <path
        d='M54.9315 28.8448H49.5198C48.991 28.8448 48.5623 28.4161 48.5623 27.8872C48.5623 27.3584 48.991 26.9297 49.5198 26.9297H54.9315C55.4603 26.9297 55.8891 27.3584 55.8891 27.8872C55.889 28.4161 55.4603 28.8448 54.9315 28.8448Z'
        fill='black'
      />
      <path
        d='M6.4803 28.8448H1.06865C0.539812 28.8448 0.111084 28.4161 0.111084 27.8872C0.111084 27.3584 0.539796 26.9297 1.06865 26.9297H6.4803C7.00914 26.9297 7.43787 27.3584 7.43787 27.8872C7.43787 28.4161 7.00916 28.8448 6.4803 28.8448Z'
        fill='black'
      />
      <path
        d='M12.1063 13.348L8.27973 9.52139C7.90578 9.14744 7.90578 8.54115 8.27973 8.16718C8.65369 7.79323 9.25997 7.79323 9.63394 8.16718L13.4605 11.9938C13.8345 12.3678 13.8345 12.974 13.4605 13.348C13.0867 13.7219 12.4803 13.722 12.1063 13.348Z'
        fill='black'
      />
      <path
        d='M25.8112 32.3011L23.0753 32.8483L21.981 27.9237L25.264 27.3765V24.6406H30.1886L30.7358 27.3765H33.4717V32.3011H30.1886V36.1313H25.8112V32.3011Z'
        fill='#C5ECE3'
      />
      <path
        d='M30.3711 36.863H25.6291C25.1003 36.863 24.6715 36.4343 24.6715 35.9054V33.5335H22.2996C21.7708 33.5335 21.342 33.1047 21.342 32.5759V27.8339C21.342 27.3051 21.7708 26.8764 22.2996 26.8764H24.6715V24.5044C24.6715 23.9756 25.1003 23.5469 25.6291 23.5469H30.3711C30.8999 23.5469 31.3287 23.9756 31.3287 24.5044V26.8764H33.7006C34.2294 26.8764 34.6581 27.3051 34.6581 27.8339V32.5759C34.6581 33.1047 34.2294 33.5335 33.7006 33.5335H31.3287V35.9054C31.3286 36.4342 30.8999 36.863 30.3711 36.863ZM26.5867 34.9478H29.4135V32.5759C29.4135 32.0471 29.8423 31.6184 30.3711 31.6184H32.743V28.7915H30.3711C29.8423 28.7915 29.4135 28.3628 29.4135 27.8339V25.462H26.5867V27.8339C26.5867 28.3628 26.158 28.7915 25.6291 28.7915H23.2572V31.6184H25.6291C26.158 31.6184 26.5867 32.0471 26.5867 32.5759V34.9478Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_5003_1753'>
        <rect width='56' height='56' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const WeightLoss = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='25' cy='12' r='9' fill='#3FC1A2' fillOpacity='0.3' />
    <path
      d='M15.5 45V40.5L30 40V45H15.5Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
      stroke='black'
    />
    <path
      d='M24.7519 12.6553C24.9199 12.8793 25.1999 12.9913 25.4239 12.9913C25.5919 12.9913 25.7599 12.9353 25.9279 12.8233C26.3199 12.5433 26.3759 12.0393 26.1519 11.6473L23.7999 8.3433C23.5199 7.9513 23.0159 7.8953 22.6239 8.1193C22.2319 8.3993 22.1199 8.9593 22.3999 9.2953L24.7519 12.6553Z'
      fill='#0F0F0F'
    />
    <path
      d='M44.24 31.1928L46.48 15.8488C46.872 13.2728 46.424 11.1448 45.136 9.63278C43.96 8.28878 42.224 7.56078 39.984 7.56078H33.6C31.976 4.76078 28.952 2.80078 25.424 2.80078C21.896 2.80078 18.816 4.76078 17.248 7.61678H10.808C8.624 7.61678 6.83201 8.34478 5.656 9.68878C4.368 11.1448 3.92 13.2728 4.312 15.9048L8.736 45.9768C9.184 49.0008 11.368 50.7928 14.616 50.7928H33.488C35.392 52.3048 37.8 53.2008 40.432 53.2008C46.704 53.2008 51.744 48.1048 51.744 41.8888C51.8 36.9608 48.608 32.7608 44.24 31.1928ZM25.424 4.48078C29.624 4.48078 33.096 7.89678 33.096 12.1528C33.096 16.4088 29.68 19.8248 25.424 19.8248C21.168 19.8248 17.752 16.4088 17.752 12.1528C17.752 7.89678 21.168 4.48078 25.424 4.48078ZM10.416 45.6968L5.992 15.6248C5.656 13.5528 5.992 11.8728 6.944 10.7528C7.784 9.80078 9.128 9.29678 10.808 9.29678H16.464C16.184 10.1928 16.016 11.1448 16.016 12.1528C16.016 17.3048 20.216 21.5048 25.368 21.5048C30.52 21.5048 34.72 17.3048 34.72 12.1528C34.72 11.1448 34.552 10.1928 34.272 9.29678H39.928C41.608 9.29678 42.952 9.80078 43.792 10.7528C44.744 11.8168 45.08 13.4968 44.744 15.6248L42.504 30.7448C41.832 30.6328 41.104 30.5208 40.376 30.5208C35.056 30.5208 30.632 34.1608 29.4 39.0888H15.4C14.952 39.0888 14.56 39.4808 14.56 39.9288V44.8008C14.56 45.2488 14.952 45.6408 15.4 45.6408H29.736C30.184 46.9288 30.856 48.1048 31.696 49.1128H14.616C12.264 49.1128 10.752 47.9368 10.416 45.6968ZM29.344 43.9608H16.296V40.8248H29.176C29.12 41.1608 29.12 41.4968 29.12 41.8888C29.12 42.6168 29.232 43.2888 29.344 43.9608ZM40.488 51.5208C35.168 51.5208 30.8 47.2088 30.8 41.8888C30.8 36.5688 35.112 32.2568 40.432 32.2568C45.752 32.2568 50.064 36.5688 50.064 41.8888C50.12 47.2088 45.808 51.5208 40.488 51.5208Z'
      fill='#0F0F0F'
    />
    <path
      d='M43.568 42.6731L41.328 44.9131V36.7931C41.328 36.3451 40.936 35.9531 40.488 35.9531C40.04 35.9531 39.648 36.3451 39.648 36.7931V44.9131L37.408 42.6731C37.072 42.3371 36.568 42.3371 36.232 42.6731C35.896 43.0091 35.896 43.5131 36.232 43.8491L39.928 47.5451C40.096 47.7131 40.32 47.7691 40.544 47.7691C40.768 47.7691 40.992 47.7131 41.16 47.5451L44.856 43.8491C45.192 43.5131 45.192 43.0091 44.856 42.6731C44.408 42.3371 43.904 42.3371 43.568 42.6731Z'
      fill='#0F0F0F'
    />
  </svg>
);
const SexualHealth = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M32 18L34 16.5L38 16L40 17L41.5 18L42.5 20L43 22V24L42 26L40.5 27.5L38.5 28.5L36.5 29L34.5 28.5L32.5 27.5L31 25.5L30 23L30.5 20L32 18Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
    />
    <path
      d='M14 17L16 15.5L20 15L22 16L23.5 17L24.5 19L25 21V23L24 25L22.5 26.5L20.5 27.5L18.5 28L16.5 27.5L14.5 26.5L13 24.5L12 22L12.5 19L14 17Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
    />
    <path
      d='M18.9642 14.6172C10.0549 14.8582 9.01979 27.3451 17.6779 29.1033L17.6778 37.882L16.1303 35.8137C15.9893 35.6329 15.7831 35.5147 15.5559 35.4843C15.3287 35.4539 15.0986 35.5139 14.9151 35.6513C14.7316 35.7887 14.6093 35.9926 14.5745 36.2192C14.5397 36.4457 14.5952 36.6769 14.729 36.8631L17.8521 41.0364C17.9337 41.1451 18.0395 41.2334 18.1611 41.2942C18.2827 41.355 18.4168 41.3867 18.5528 41.3867C18.6888 41.3867 18.8229 41.355 18.9445 41.2942C19.0661 41.2334 19.1719 41.1451 19.2535 41.0364L22.3766 36.8631C22.5105 36.6769 22.5659 36.4457 22.5311 36.2191C22.4963 35.9925 22.374 35.7886 22.1905 35.6512C22.007 35.5138 21.7769 35.4539 21.5497 35.4843C21.3224 35.5147 21.1162 35.633 20.9752 35.8138L19.4278 37.882V29.2004C28.7591 28.2988 28.3624 14.9431 18.9642 14.6172ZM18.9642 27.4739C17.4919 27.4723 16.0803 26.8867 15.0392 25.8456C13.9981 24.8044 13.4125 23.3929 13.4109 21.9205C13.6714 14.5706 24.2582 14.5725 24.5176 21.9206C24.5159 23.3929 23.9303 24.8045 22.8892 25.8456C21.8481 26.8867 20.4366 27.4723 18.9642 27.4739Z'
      fill='#0F0F0F'
    />
    <path
      d='M44.3392 21.9205C44.3371 19.9842 43.5669 18.1278 42.1978 16.7586C40.8286 15.3895 38.9722 14.6193 37.0359 14.6172C27.8849 14.8898 27.1639 27.8351 36.161 29.1663L36.1609 33.5015H31.0083C30.7762 33.5015 30.5537 33.5936 30.3896 33.7577C30.2255 33.9218 30.1333 34.1444 30.1333 34.3765C30.1333 34.6085 30.2255 34.8311 30.3896 34.9952C30.5537 35.1593 30.7762 35.2515 31.0083 35.2515H36.1609V40.404C36.1655 40.6331 36.2597 40.8512 36.4233 41.0115C36.5869 41.1719 36.8068 41.2617 37.0359 41.2617C37.265 41.2617 37.4849 41.1719 37.6485 41.0115C37.8121 40.8511 37.9063 40.633 37.9109 40.404V35.2515H43.0635C43.2926 35.247 43.5108 35.1528 43.6712 34.9892C43.8317 34.8256 43.9216 34.6056 43.9216 34.3764C43.9215 34.1473 43.8317 33.9273 43.6712 33.7637C43.5108 33.6001 43.2925 33.5059 43.0634 33.5015H37.9109V29.1663C39.682 28.9511 41.3133 28.0956 42.4974 26.7609C43.6814 25.4263 44.3365 23.7047 44.3392 21.9205ZM31.4825 21.9205C31.4841 20.4482 32.0697 19.0366 33.1108 17.9955C34.152 16.9544 35.5635 16.3688 37.0359 16.3672C44.3858 16.6277 44.3839 27.2144 37.0358 27.4739C35.5635 27.4722 34.1519 26.8866 33.1108 25.8455C32.0697 24.8044 31.4841 23.3929 31.4825 21.9205Z'
      fill='#0F0F0F'
    />
    <path
      d='M28 3.5C21.5044 3.50729 15.277 6.09087 10.6839 10.6839C6.09087 15.277 3.50729 21.5044 3.5 28C4.84553 60.5026 51.1594 60.4932 52.5 27.9998C52.4927 21.5043 49.9091 15.2769 45.316 10.6839C40.723 6.09084 34.4955 3.50728 28 3.5ZM28 50.75C21.9684 50.7432 16.1858 48.3442 11.9208 44.0792C7.65579 39.8142 5.25675 34.0316 5.25 28C6.49935 -2.18102 49.5052 -2.17223 50.75 28.0002C50.7432 34.0318 48.3442 39.8143 44.0792 44.0793C39.8142 48.3442 34.0316 50.7433 28 50.75Z'
      fill='#0F0F0F'
    />
  </svg>
);
const AllConditions = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.1121 52.25H45.2864C46.1116 52.2494 46.9028 51.9213 47.4863 51.3378C48.0698 50.7543 48.3979 49.9631 48.3985 49.1379V7.11212C48.3979 6.28693 48.0698 5.49572 47.4863 4.91223C46.9028 4.32873 46.1116 4.00064 45.2864 4H10.1121C9.28693 4.00064 8.49572 4.32873 7.91223 4.91223C7.32873 5.49572 7.00064 6.28693 7 7.11212V49.1379C7.00064 49.9631 7.32873 50.7543 7.91223 51.3378C8.49572 51.9213 9.28693 52.2494 10.1121 52.25ZM8.60833 7.11212C8.60918 6.71356 8.76789 6.33155 9.04972 6.04972C9.33155 5.76789 9.71356 5.60918 10.1121 5.60833H45.2864C45.6849 5.60918 46.0669 5.76789 46.3488 6.04972C46.6306 6.33155 46.7893 6.71356 46.7902 7.11212V49.1379C46.7893 49.5364 46.6306 49.9184 46.3488 50.2003C46.0669 50.4821 45.6849 50.6408 45.2864 50.6417H10.1121C9.71356 50.6408 9.33155 50.4821 9.04972 50.2003C8.76789 49.9184 8.60918 49.5364 8.60833 49.1379V7.11212Z'
      fill='#0F0F0F'
    />
    <path
      d='M15.0144 36.2333H29.9566C30.1699 36.2333 30.3744 36.1486 30.5252 35.9978C30.676 35.847 30.7608 35.6424 30.7608 35.4292C30.7608 35.2159 30.676 35.0113 30.5252 34.8605C30.3744 34.7097 30.1699 34.625 29.9566 34.625H15.0144C14.8011 34.625 14.5966 34.7097 14.4457 34.8605C14.2949 35.0113 14.2102 35.2159 14.2102 35.4292C14.2102 35.6424 14.2949 35.847 14.4457 35.9978C14.5966 36.1486 14.8011 36.2333 15.0144 36.2333Z'
      fill='#0F0F0F'
    />
    <path
      d='M15.0144 40.9013H40.3842C40.5975 40.9013 40.802 40.8166 40.9529 40.6658C41.1037 40.515 41.1884 40.3104 41.1884 40.0971C41.1884 39.8839 41.1037 39.6793 40.9529 39.5285C40.802 39.3777 40.5975 39.293 40.3842 39.293H15.0144C14.8011 39.293 14.5966 39.3777 14.4457 39.5285C14.2949 39.6793 14.2102 39.8839 14.2102 40.0971C14.2102 40.3104 14.2949 40.515 14.4457 40.6658C14.5966 40.8166 14.8011 40.9013 15.0144 40.9013Z'
      fill='#0F0F0F'
    />
    <path
      d='M15.0144 46.4247H21.2402C21.4535 46.4247 21.6581 46.34 21.8089 46.1892C21.9597 46.0384 22.0444 45.8339 22.0444 45.6206C22.0444 45.4073 21.9597 45.2028 21.8089 45.0519C21.6581 44.9011 21.4535 44.8164 21.2402 44.8164H15.0144C14.8011 44.8164 14.5966 44.9011 14.4457 45.0519C14.2949 45.2028 14.2102 45.4073 14.2102 45.6206C14.2102 45.8339 14.2949 46.0384 14.4457 46.1892C14.5966 46.34 14.8011 46.4247 15.0144 46.4247Z'
      fill='#0F0F0F'
    />
    <path
      d='M30 14.5H25.5V18H22V22.5H25.5V25.5H30V22H33.5V18H30V14.5Z'
      fill='#3FC1A2'
      fillOpacity='0.3'
    />
    <path
      d='M33.1742 17.2382C33.172 17.2382 33.17 17.2382 33.1678 17.2382H30.5494V14.6134C30.553 14.0841 30.1267 13.652 29.5973 13.6484C29.5951 13.6484 29.5929 13.6484 29.5908 13.6484H25.808C25.2787 13.6484 24.8495 14.0776 24.8495 14.607V17.2318H22.2311C21.7017 17.2283 21.2697 17.6545 21.2661 18.1839C21.2661 18.1882 21.2661 18.1925 21.2661 18.1968V21.9732C21.2661 22.5026 21.6953 22.9317 22.2247 22.9317H24.8495V25.5501C24.8459 26.0795 25.2722 26.5116 25.8016 26.5151C25.8038 26.5151 25.806 26.5151 25.808 26.5151H29.5844C30.1138 26.5151 30.543 26.0859 30.543 25.5565V22.9317H33.1678C33.6972 22.9353 34.1292 22.509 34.1328 21.9796C34.1328 21.9774 34.1328 21.9753 34.1328 21.9732V18.1968C34.1328 17.6674 33.7037 17.2382 33.1742 17.2382ZM32.8461 21.6451H29.9061C29.5508 21.6451 29.2627 21.9331 29.2627 22.2884V25.2284H26.1361V22.2884C26.1361 21.9331 25.8481 21.6451 25.4928 21.6451H22.5528V18.5249H25.4928C25.8481 18.5249 26.1361 18.2369 26.1361 17.8816V14.9351H29.2563V17.8751C29.2563 18.2304 29.5444 18.5185 29.8996 18.5185H32.8461V21.6451Z'
      fill='#0F0F0F'
    />
  </svg>
);
const ArrowRightWhite = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 4.16536L13.3333 9.9987L7.5 15.832'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowLeft = () => (
  <svg
    width='9'
    height='14'
    viewBox='0 0 9 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.5 1.17318L1.66667 7.00651L7.5 12.8398'
      stroke='#0F0F0F'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowRightBg = () => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='36' height='36' rx='18' fill='white' />
    <path
      d='M15.5 12.1654L21.3333 17.9987L15.5 23.832'
      stroke='#0F0F0F'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const PrescriptionCheck = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM14.0607 9.06066C14.6464 8.47487 14.6464 7.52513 14.0607 6.93934C13.4749 6.35355 12.5251 6.35355 11.9393 6.93934L9 9.87868L8.06066 8.93934C7.47487 8.35355 6.52513 8.35355 5.93934 8.93934C5.35355 9.52513 5.35355 10.4749 5.93934 11.0607L7.93934 13.0607C8.52513 13.6464 9.47487 13.6464 10.0607 13.0607L14.0607 9.06066Z'
      fill='black'
    />
    <path
      d='M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM14.0607 9.06066C14.6464 8.47487 14.6464 7.52513 14.0607 6.93934C13.4749 6.35355 12.5251 6.35355 11.9393 6.93934L9 9.87868L8.06066 8.93934C7.47487 8.35355 6.52513 8.35355 5.93934 8.93934C5.35355 9.52513 5.35355 10.4749 5.93934 11.0607L7.93934 13.0607C8.52513 13.6464 9.47487 13.6464 10.0607 13.0607L14.0607 9.06066Z'
      fill='#C5ECE3'
    />
    <path
      d='M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM14.0607 9.06066C14.6464 8.47487 14.6464 7.52513 14.0607 6.93934C13.4749 6.35355 12.5251 6.35355 11.9393 6.93934L9 9.87868L8.06066 8.93934C7.47487 8.35355 6.52513 8.35355 5.93934 8.93934C5.35355 9.52513 5.35355 10.4749 5.93934 11.0607L7.93934 13.0607C8.52513 13.6464 9.47487 13.6464 10.0607 13.0607L14.0607 9.06066Z'
      stroke='#195D9D'
    />
  </svg>
);
const PersonIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z'
      stroke='#0F0F0F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const TickerIcon1 = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3073_50738)'>
      <path
        d='M9.5 17C7.36312 17 5.35413 16.1679 3.84313 14.6569C2.33213 13.1459 1.5 11.1369 1.5 9C1.5 6.86312 2.33216 4.85416 3.84313 3.34313C5.35409 1.83209 7.36312 1 9.5 1C11.6369 1 13.6459 1.83213 15.1569 3.34313C16.6679 4.85413 17.5 6.86312 17.5 9C17.5 11.1369 16.6678 13.1458 15.1569 14.6569C13.6459 16.1679 11.6369 17 9.5 17ZM9.5 2C5.64019 2 2.5 5.14019 2.5 9C2.5 12.8598 5.64019 16 9.5 16C13.3598 16 16.5 12.8598 16.5 9C16.5 5.14019 13.3598 2 9.5 2Z'
        fill='white'
      />
      <path
        d='M9.5 8.5C8.81075 8.5 8.25 7.93925 8.25 7.25C8.25 6.56075 8.81075 6 9.5 6C10.1892 6 10.75 6.56075 10.75 7.25C10.75 7.52612 10.9738 7.75 11.25 7.75C11.5262 7.75 11.75 7.52612 11.75 7.25C11.75 6.18122 11.0007 5.28475 10 5.05669V4.5C10 4.22387 9.77616 4 9.5 4C9.22384 4 9 4.22387 9 4.5V5.05669C7.99931 5.28475 7.25 6.18122 7.25 7.25C7.25 8.49066 8.25934 9.5 9.5 9.5C10.1892 9.5 10.75 10.0608 10.75 10.75C10.75 11.4392 10.1892 12 9.5 12C8.81075 12 8.25 11.4392 8.25 10.75C8.25 10.4739 8.02616 10.25 7.75 10.25C7.47384 10.25 7.25 10.4739 7.25 10.75C7.25 11.8188 7.99931 12.7153 9 12.9433V13.5C9 13.7761 9.22384 14 9.5 14C9.77616 14 10 13.7761 10 13.5V12.9433C11.0007 12.7153 11.75 11.8188 11.75 10.75C11.75 9.50934 10.7407 8.5 9.5 8.5Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_3073_50738'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(1.5 1)'
        />
      </clipPath>
    </defs>
  </svg>
);
const TickerIcon2 = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3073_50745)'>
      <path
        d='M18.2557 13.9197L16.8417 12.0203V4.04531C16.8417 2.97999 15.975 2.11328 14.9097 2.11328H4.09034C3.02502 2.11328 2.15832 2.97999 2.15832 4.04531V12.0203L0.744321 13.9197C0.465021 14.2949 0.421919 14.7877 0.631878 15.2057C0.841801 15.6236 1.26281 15.8833 1.73053 15.8833H17.2694C17.7372 15.8833 18.1582 15.6237 18.3681 15.2057C18.5781 14.7877 18.535 14.2949 18.2557 13.9197ZM3.21215 4.04531C3.21215 3.56107 3.60611 3.16711 4.09034 3.16711H14.9097C15.3939 3.16711 15.7879 3.56107 15.7879 4.04531V11.668H3.21215V4.04531ZM17.4264 14.7327C17.4083 14.7688 17.3638 14.8295 17.2695 14.8295H1.73053C1.63625 14.8295 1.59174 14.7688 1.57358 14.7327C1.55539 14.6966 1.53332 14.6246 1.58963 14.549L2.94985 12.7218H16.0502L17.4104 14.549C17.4667 14.6246 17.4446 14.6966 17.4264 14.7327Z'
        fill='white'
      />
      <path
        d='M10.9386 4.22266H8.05817C7.76717 4.22266 7.53125 4.45857 7.53125 4.74957C7.53125 5.04057 7.76717 5.27649 8.05817 5.27649H10.9386C11.2296 5.27649 11.4656 5.04057 11.4656 4.74957C11.4656 4.45857 11.2296 4.22266 10.9386 4.22266Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_3073_50745'>
        <rect width='18' height='18' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);
const TickerIcon3 = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 16C9.28616 15.9998 9.07593 15.9493 8.88932 15.8531L6.46975 14.615C5.26695 13.9989 4.26472 13.098 3.56678 12.0053C2.86884 10.9127 2.50054 9.66816 2.5 8.40043V4.96429C2.49979 4.6782 2.61484 4.40223 2.82285 4.1898C3.03087 3.97736 3.31705 3.84359 3.626 3.81437C4.58855 3.72045 5.53588 3.52321 6.44872 3.22669C7.2857 2.95421 8.08862 2.59999 8.84375 2.1701C9.04134 2.05881 9.26845 1.99994 9.50005 2C9.73165 2.00006 9.95873 2.05903 10.1562 2.17042C10.9115 2.60009 11.7144 2.95418 12.5513 3.22669C13.4641 3.52322 14.4115 3.72046 15.374 3.81439C15.6829 3.84361 15.9691 3.97738 16.1771 4.18981C16.3852 4.40224 16.5002 4.67821 16.5 4.96429V8.40045C16.4995 9.66818 16.1312 10.9127 15.4332 12.0054C14.7353 13.098 13.7331 13.9989 12.5302 14.615L10.11 15.8534C9.92356 15.9494 9.71357 15.9999 9.5 16ZM9.5 2.99093C9.46836 2.9908 9.4373 2.99874 9.41026 3.01386C8.58958 3.48069 7.71711 3.86574 6.80769 4.16181C5.81556 4.48431 4.78585 4.69868 3.73958 4.80054C3.69513 4.8041 3.65374 4.8229 3.62362 4.85322C3.59349 4.88354 3.57683 4.92318 3.57692 4.96429V8.40045C3.57735 9.49127 3.89424 10.5622 4.49481 11.5023C5.09538 12.4424 5.95779 13.2176 6.99279 13.7477L9.41306 14.986C9.43949 14.9997 9.46928 15.007 9.49961 15.007C9.52993 15.0071 9.55976 15 9.58624 14.9864L12.0072 13.7477C13.0422 13.2176 13.9046 12.4424 14.5052 11.5023C15.1058 10.5622 15.4227 9.49127 15.4231 8.40045V4.96429C15.4232 4.92319 15.4065 4.88355 15.3764 4.85323C15.3463 4.82291 15.3049 4.80412 15.2604 4.80056C14.2142 4.6987 13.1844 4.48432 12.1923 4.16181C11.2829 3.86573 10.4104 3.481 9.58974 3.01416C9.5628 2.9988 9.53169 2.99075 9.5 2.99093Z'
      fill='white'
    />
    <path
      d='M8.99767 11C8.8753 11.0002 8.75715 10.9512 8.66585 10.8624L7.16667 9.40949C7.06806 9.3134 7.00843 9.1786 7.00083 9.03465C6.99323 8.8907 7.03829 8.74933 7.12613 8.64154C7.21397 8.53375 7.33743 8.46833 7.46944 8.45962C7.60145 8.45091 7.73125 8.49962 7.83037 8.59507L8.96582 9.69538L11.132 7.17659C11.1766 7.12347 11.2306 7.08055 11.2906 7.0503C11.3506 7.02005 11.4155 7.00309 11.4815 7.00038C11.5476 6.99768 11.6135 7.00929 11.6754 7.03455C11.7373 7.05981 11.794 7.09821 11.8422 7.14753C11.8904 7.19685 11.9292 7.25611 11.9562 7.32187C11.9833 7.38764 11.9981 7.4586 11.9998 7.53065C12.0016 7.6027 11.9901 7.6744 11.9663 7.74161C11.9424 7.80882 11.9065 7.8702 11.8607 7.92219L9.3621 10.828C9.31543 10.8824 9.259 10.9257 9.1963 10.9553C9.1336 10.9849 9.06599 11.0001 8.99767 11Z'
      fill='white'
    />
  </svg>
);
const TickerIcon4 = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 16C9.28616 15.9998 9.07593 15.9493 8.88932 15.8531L6.46975 14.615C5.26695 13.9989 4.26472 13.098 3.56678 12.0053C2.86884 10.9127 2.50054 9.66816 2.5 8.40043V4.96429C2.49979 4.6782 2.61484 4.40223 2.82285 4.1898C3.03087 3.97736 3.31705 3.84359 3.626 3.81437C4.58855 3.72045 5.53588 3.52321 6.44872 3.22669C7.2857 2.95421 8.08862 2.59999 8.84375 2.1701C9.04134 2.05881 9.26845 1.99994 9.50005 2C9.73165 2.00006 9.95873 2.05903 10.1562 2.17042C10.9115 2.60009 11.7144 2.95418 12.5513 3.22669C13.4641 3.52322 14.4115 3.72046 15.374 3.81439C15.6829 3.84361 15.9691 3.97738 16.1771 4.18981C16.3852 4.40224 16.5002 4.67821 16.5 4.96429V8.40045C16.4995 9.66818 16.1312 10.9127 15.4332 12.0054C14.7353 13.098 13.7331 13.9989 12.5302 14.615L10.11 15.8534C9.92356 15.9494 9.71357 15.9999 9.5 16ZM9.5 2.99093C9.46836 2.9908 9.4373 2.99874 9.41026 3.01386C8.58958 3.48069 7.71711 3.86574 6.80769 4.16181C5.81556 4.48431 4.78585 4.69868 3.73958 4.80054C3.69513 4.8041 3.65374 4.8229 3.62362 4.85322C3.59349 4.88354 3.57683 4.92318 3.57692 4.96429V8.40045C3.57735 9.49127 3.89424 10.5622 4.49481 11.5023C5.09538 12.4424 5.95779 13.2176 6.99279 13.7477L9.41306 14.986C9.43949 14.9997 9.46928 15.007 9.49961 15.007C9.52993 15.0071 9.55976 15 9.58624 14.9864L12.0072 13.7477C13.0422 13.2176 13.9046 12.4424 14.5052 11.5023C15.1058 10.5622 15.4227 9.49127 15.4231 8.40045V4.96429C15.4232 4.92319 15.4065 4.88355 15.3764 4.85323C15.3463 4.82291 15.3049 4.80412 15.2604 4.80056C14.2142 4.6987 13.1844 4.48432 12.1923 4.16181C11.2829 3.86573 10.4104 3.481 9.58974 3.01416C9.5628 2.9988 9.53169 2.99075 9.5 2.99093Z'
      fill='white'
    />
    <path
      d='M8.75 8.35H8.85V8.25V6.85H10.15V8.25V8.35H10.25H11.65V9.65H10.25H10.15V9.75V11.15H8.85V9.75V9.65H8.75H7.35V8.35H8.75Z'
      fill='white'
      stroke='url(#paint0_linear_3073_50756)'
      strokeWidth='0.2'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3073_50756'
        x1='7.25'
        y1='9'
        x2='11.75'
        y2='9'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#41C7A2' />
        <stop offset='1' stopColor='#195D9D' />
      </linearGradient>
    </defs>
  </svg>
);
const TickerIcon5 = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.354 7.70457V5.63368C14.354 4.54636 14.354 4.0027 14.1423 3.5874C13.9562 3.22209 13.6592 2.92508 13.2939 2.73895C12.8786 2.52734 12.3349 2.52734 11.2476 2.52734H7.10584C6.01853 2.52734 5.47487 2.52734 5.05957 2.73895C4.69426 2.92508 4.39725 3.22209 4.21112 3.5874C3.99951 4.0027 3.99951 4.54636 3.99951 5.63368V12.3641C3.99951 13.4514 3.99951 13.995 4.21112 14.4103C4.39725 14.7757 4.69426 15.0727 5.05957 15.2588C5.47487 15.4704 6.01853 15.4704 7.10584 15.4704H9.17673M9.50031 8.35172H6.58812M7.23528 10.9403H6.58812M11.7653 5.76311H6.58812M12.4107 10.8307C11.8932 10.2424 11.0301 10.0842 10.3817 10.6229C9.73319 11.1615 9.6419 12.0622 10.1511 12.6992C10.6604 13.3363 12.4107 14.8232 12.4107 14.8232C12.4107 14.8232 14.1611 13.3363 14.6703 12.6992C15.1796 12.0622 15.0994 11.1559 14.4398 10.6229C13.7802 10.0899 12.9283 10.2424 12.4107 10.8307Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const MenuUserIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3900_31469)'>
      <path
        d='M9.99984 11.2513C11.8408 11.2513 13.3332 9.75892 13.3332 7.91797C13.3332 6.07702 11.8408 4.58464 9.99984 4.58464C8.15889 4.58464 6.6665 6.07702 6.6665 7.91797C6.6665 9.75892 8.15889 11.2513 9.99984 11.2513Z'
        fill='#3FC1A2'
        fillOpacity='0.2'
      />
      <path
        d='M9.99984 18.3346C14.6022 18.3346 18.3332 14.6037 18.3332 10.0013C18.3332 5.39893 14.6022 1.66797 9.99984 1.66797C5.39746 1.66797 1.6665 5.39893 1.6665 10.0013C1.6665 14.6037 5.39746 18.3346 9.99984 18.3346Z'
        fill='#3FC1A2'
        fillOpacity='0.2'
      />
      <path
        d='M4.43008 16.2C4.93702 15.0056 6.12061 14.168 7.49984 14.168H12.4998C13.8791 14.168 15.0626 15.0056 15.5696 16.2M13.3332 7.91797C13.3332 9.75892 11.8408 11.2513 9.99984 11.2513C8.15889 11.2513 6.6665 9.75892 6.6665 7.91797C6.6665 6.07702 8.15889 4.58464 9.99984 4.58464C11.8408 4.58464 13.3332 6.07702 13.3332 7.91797ZM18.3332 10.0013C18.3332 14.6037 14.6022 18.3346 9.99984 18.3346C5.39746 18.3346 1.6665 14.6037 1.6665 10.0013C1.6665 5.39893 5.39746 1.66797 9.99984 1.66797C14.6022 1.66797 18.3332 5.39893 18.3332 10.0013Z'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_3900_31469'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const DashboardIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='0.8'
      d='M5.77168 10.6682C6.14172 12.1059 7.4468 13.1682 9 13.1682C10.5532 13.1682 11.8583 12.1059 12.2283 10.6682M8.18141 1.30492L2.52949 5.70086C2.15168 5.99471 1.96278 6.14163 1.82669 6.32563C1.70614 6.48862 1.61633 6.67224 1.56169 6.86746C1.5 7.08785 1.5 7.32717 1.5 7.8058V13.8349C1.5 14.7683 1.5 15.235 1.68166 15.5916C1.84144 15.9052 2.09641 16.1601 2.41002 16.3199C2.76654 16.5016 3.23325 16.5016 4.16667 16.5016H13.8333C14.7668 16.5016 15.2335 16.5016 15.59 16.3199C15.9036 16.1601 16.1586 15.9052 16.3183 15.5916C16.5 15.235 16.5 14.7683 16.5 13.8349V7.8058C16.5 7.32717 16.5 7.08785 16.4383 6.86746C16.3837 6.67224 16.2939 6.48862 16.1733 6.32563C16.0372 6.14163 15.8483 5.99471 15.4705 5.70086L9.81859 1.30492C9.52582 1.07721 9.37943 0.963353 9.21779 0.919588C9.07516 0.880971 8.92484 0.880971 8.78221 0.919588C8.62057 0.963353 8.47418 1.07721 8.18141 1.30492Z'
      stroke='#606060'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const LogoutIcon = () => (
  <svg
    width='20'
    height='18'
    viewBox='0 0 20 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      opacity='0.8'
      d='M15.0003 5.66667L18.3337 9M18.3337 9L15.0003 12.3333M18.3337 9H7.50033M12.5003 2.50337C11.438 1.86523 10.2047 1.5 8.88921 1.5C4.90049 1.5 1.66699 4.85786 1.66699 9C1.66699 13.1421 4.90049 16.5 8.88921 16.5C10.2047 16.5 11.438 16.1348 12.5003 15.4966'
      stroke='#606060'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const ArrowLocation = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.4688 5V13.125C15.4688 13.2493 15.4194 13.3685 15.3315 13.4565C15.2436 13.5444 15.1243 13.5938 15 13.5938C14.8757 13.5938 14.7565 13.5444 14.6686 13.4565C14.5807 13.3685 14.5313 13.2493 14.5313 13.125V6.13125L5.33128 15.3313C5.24242 15.4141 5.12489 15.4591 5.00345 15.457C4.88201 15.4548 4.76615 15.4056 4.68026 15.3198C4.59438 15.2339 4.54518 15.118 4.54304 14.9966C4.5409 14.8751 4.58598 14.7576 4.66878 14.6687L13.8688 5.46875H6.87503C6.75071 5.46875 6.63148 5.41936 6.54357 5.33146C6.45566 5.24355 6.40628 5.12432 6.40628 5C6.40628 4.87568 6.45566 4.75645 6.54357 4.66854C6.63148 4.58064 6.75071 4.53125 6.87503 4.53125H15C15.1243 4.53125 15.2436 4.58064 15.3315 4.66854C15.4194 4.75645 15.4688 4.87568 15.4688 5Z'
      fill='#343330'
    />
  </svg>
);
const ZapIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.8331 1.66797L3.41094 10.5745C3.12026 10.9233 2.97492 11.0977 2.9727 11.245C2.97077 11.3731 3.02783 11.4949 3.12744 11.5754C3.24201 11.668 3.46904 11.668 3.92308 11.668H9.99972L9.16639 18.3346L16.5885 9.42809C16.8792 9.07928 17.0245 8.90488 17.0267 8.75758C17.0287 8.62954 16.9716 8.50771 16.872 8.42722C16.7574 8.33464 16.5304 8.33464 16.0764 8.33464H9.99972L10.8331 1.66797Z'
      fill='#BEE3D9'
      stroke='#0F0F0F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const TimerIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3782_20181)'>
      <path
        d='M10.0003 18.3346C14.6027 18.3346 18.3337 14.6037 18.3337 10.0013C18.3337 5.39893 14.6027 1.66797 10.0003 1.66797C5.39795 1.66797 1.66699 5.39893 1.66699 10.0013C1.66699 14.6037 5.39795 18.3346 10.0003 18.3346Z'
        fill='#BEE3D9'
      />
      <path
        d='M10.0003 10.8346C10.4606 10.8346 10.8337 10.4615 10.8337 10.0013C10.8337 9.54107 10.4606 9.16797 10.0003 9.16797C9.54009 9.16797 9.16699 9.54107 9.16699 10.0013C9.16699 10.4615 9.54009 10.8346 10.0003 10.8346Z'
        fill='#BEE3D9'
      />
      <path
        d='M13.7502 6.2513L10.0002 10.0013M18.3337 10.0013C18.3337 14.6037 14.6027 18.3346 10.0003 18.3346C5.39795 18.3346 1.66699 14.6037 1.66699 10.0013C1.66699 5.39893 5.39795 1.66797 10.0003 1.66797C14.6027 1.66797 18.3337 5.39893 18.3337 10.0013ZM10.8337 10.0013C10.8337 10.4615 10.4606 10.8346 10.0003 10.8346C9.54009 10.8346 9.16699 10.4615 9.16699 10.0013C9.16699 9.54107 9.54009 9.16797 10.0003 9.16797C10.4606 9.16797 10.8337 9.54107 10.8337 10.0013Z'
        stroke='#0F0F0F'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_3782_20181'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const NoteIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.33301 5.66797C3.33301 4.26784 3.33301 3.56777 3.60549 3.03299C3.84517 2.56259 4.22763 2.18014 4.69803 1.94045C5.23281 1.66797 5.93288 1.66797 7.33301 1.66797H11.6663L16.6663 6.66797V14.3346C16.6663 15.7348 16.6663 16.4348 16.3939 16.9696C16.1542 17.44 15.7717 17.8225 15.3013 18.0622C14.7665 18.3346 14.0665 18.3346 12.6663 18.3346H7.33301C5.93288 18.3346 5.23281 18.3346 4.69803 18.0622C4.22763 17.8225 3.84517 17.44 3.60549 16.9696C3.33301 16.4348 3.33301 15.7348 3.33301 14.3346V5.66797Z'
      fill='#BEE3D9'
    />
    <path
      d='M11.6663 1.89258V5.3347C11.6663 5.80141 11.6663 6.03476 11.7572 6.21302C11.8371 6.36982 11.9645 6.49731 12.1213 6.5772C12.2996 6.66803 12.533 6.66803 12.9997 6.66803H16.4418M9.99967 15.0013V10.0013M7.49967 12.5013H12.4997M11.6663 1.66797H7.33301C5.93288 1.66797 5.23281 1.66797 4.69803 1.94045C4.22763 2.18014 3.84517 2.56259 3.60549 3.03299C3.33301 3.56777 3.33301 4.26784 3.33301 5.66797V14.3346C3.33301 15.7348 3.33301 16.4348 3.60549 16.9696C3.84517 17.44 4.22763 17.8225 4.69803 18.0622C5.23281 18.3346 5.93288 18.3346 7.33301 18.3346H12.6663C14.0665 18.3346 14.7665 18.3346 15.3013 18.0622C15.7717 17.8225 16.1542 17.44 16.3939 16.9696C16.6663 16.4348 16.6663 15.7348 16.6663 14.3346V6.66797L11.6663 1.66797Z'
      stroke='#0F0F0F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const BlackBolt = () => (
  <svg
    width='13'
    height='20'
    viewBox='0 0 13 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.53123 6.87371V0.788714C7.56123 0.638714 7.50523 0.282714 7.03823 0.0637143C6.63123 -0.127286 6.18823 0.154714 6.05523 0.337714C4.02623 3.57771 0.240232 10.3947 0.0922323 10.7367C-0.0947677 11.1687 0.0322323 11.4387 0.210232 11.6367C0.342232 11.7867 0.658232 11.8747 0.827232 11.8747H4.94323L4.06523 19.3197C4.07823 19.4917 4.22023 19.8647 4.69223 19.9777C5.16423 20.0907 5.48923 19.7497 5.59223 19.5657L12.3222 8.17771C12.4202 8.02771 12.6222 7.62771 12.4072 7.27771C12.3247 7.14757 12.2091 7.04167 12.0722 6.97087C11.9354 6.90006 11.7821 6.86688 11.6282 6.87471L7.53123 6.87371Z'
      fill='#121111'
    />
  </svg>
);
const GreenTick = () => (
  <svg
    width='21'
    height='16'
    viewBox='0 0 21 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.12001 15.0152L20.105 3.03019L17.725 0.650194L8.12001 10.2552L3.27501 5.41019L0.895012 7.79019L8.12001 15.0152Z'
      fill='#208260'
    />
  </svg>
);
const RedCross = () => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.5 2.875L3.5 14.875M3.5 2.875L9.5 8.875L15.5 14.875'
      stroke='#FF1A1A'
      strokeWidth='4'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </svg>
);
const BoltWhite = () => (
  <svg
    width='14'
    height='21'
    viewBox='0 0 14 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.3979 7.21746V1.13246C8.4279 0.982464 8.3719 0.626464 7.9049 0.407464C7.4979 0.216464 7.0549 0.498464 6.9219 0.681464C4.8929 3.92146 1.1069 10.7385 0.958899 11.0805C0.771899 11.5125 0.898899 11.7825 1.0769 11.9805C1.2089 12.1305 1.5249 12.2185 1.6939 12.2185H5.8099L4.9319 19.6635C4.9449 19.8355 5.0869 20.2085 5.5589 20.3215C6.0309 20.4345 6.3559 20.0935 6.4589 19.9095L13.1889 8.52146C13.2869 8.37146 13.4889 7.97146 13.2739 7.62146C13.1914 7.49132 13.0758 7.38542 12.9389 7.31462C12.802 7.24381 12.6488 7.21063 12.4949 7.21846L8.3979 7.21746Z'
      fill='white'
    />
  </svg>
);
const ArrowWhiteSmall = () => (
  <svg
    width='17'
    height='15'
    viewBox='0 0 17 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.8022 8.48075C16.2012 8.09888 16.2151 7.46587 15.8332 7.06687L9.61037 0.564861C9.2285 0.165865 8.59549 0.151977 8.1965 0.533842C7.7975 0.915707 7.78361 1.54872 8.16548 1.94772L13.6969 7.72728L7.91733 13.2587C7.51833 13.6406 7.50445 14.2736 7.88631 14.6726C8.26818 15.0716 8.90119 15.0855 9.30019 14.7036L15.8022 8.48075ZM1 7.44873L0.978067 8.44849L15.0888 8.75806L15.1108 7.7583L15.1327 6.75854L1.02193 6.44897L1 7.44873Z'
      fill='white'
    />
  </svg>
);
const TheI = () => (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_24362_9799)'>
      <rect x='0.5' width='20' height='20' rx='10' fill='#D9D9D9' />
      <path
        d='M11.95 9.15C11.95 9.61667 11.8 10.4222 11.5 11.5667C11.2 12.7 11.05 13.4444 11.05 13.8C11.05 14.1444 11.1 14.3167 11.2 14.3167C11.2667 14.3167 11.5222 14.2111 11.9667 14L12.1667 13.9L12.45 14.4833C12.35 14.5722 12.2167 14.6833 12.05 14.8167C11.8833 14.95 11.5722 15.1333 11.1167 15.3667C10.6611 15.5889 10.2389 15.7 9.85 15.7C9.46111 15.7 9.15556 15.5833 8.93333 15.35C8.71111 15.1056 8.6 14.7833 8.6 14.3833C8.6 13.9722 8.73889 13.25 9.01667 12.2167C9.29444 11.1722 9.43333 10.4944 9.43333 10.1833C9.43333 9.71667 9.28889 9.27778 9 8.86667L8.85 8.66667L8.86667 8.45C9.45556 8.28333 10.4111 8.2 11.7333 8.2C11.8778 8.36667 11.95 8.68333 11.95 9.15ZM10.05 6.38333C9.82778 6.16111 9.71667 5.86667 9.71667 5.5C9.71667 5.13333 9.86667 4.81111 10.1667 4.53333C10.4778 4.25556 10.8333 4.11667 11.2333 4.11667C11.6333 4.11667 11.9444 4.22778 12.1667 4.45C12.3889 4.67222 12.5 4.96667 12.5 5.33333C12.5 5.68889 12.3389 6.00556 12.0167 6.28333C11.7056 6.56111 11.3556 6.7 10.9667 6.7C10.5778 6.7 10.2722 6.59444 10.05 6.38333Z'
        fill='#717171'
      />
    </g>
    <rect
      x='1.33333'
      y='0.833333'
      width='18.3333'
      height='18.3333'
      rx='9.16667'
      stroke='#697080'
      strokeWidth='1.66667'
    />
    <defs>
      <clipPath id='clip0_24362_9799'>
        <rect x='0.5' width='20' height='20' rx='10' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const ArrowRightLong = () => (
  <svg
    width='25'
    height='15'
    viewBox='0 0 25 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M24.7071 8.07039C25.0976 7.67986 25.0976 7.0467 24.7071 6.65617L18.3431 0.292213C17.9526 -0.0983109 17.3195 -0.0983109 16.9289 0.292213C16.5384 0.682738 16.5384 1.3159 16.9289 1.70643L22.5858 7.36328L16.9289 13.0201C16.5384 13.4107 16.5384 14.0438 16.9289 14.4343C17.3195 14.8249 17.9526 14.8249 18.3431 14.4343L24.7071 8.07039ZM0 7.36328V8.36328H24V7.36328V6.36328H0V7.36328Z'
      fill='white'
    />
  </svg>
);
const ArrowRightShort = () => (
  <svg
    width='17'
    height='15'
    viewBox='0 0 17 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.7071 8.07039C17.0976 7.67986 17.0976 7.0467 16.7071 6.65617L10.3431 0.292213C9.95262 -0.0983109 9.31946 -0.0983109 8.92893 0.292213C8.53841 0.682738 8.53841 1.3159 8.92893 1.70643L14.5858 7.36328L8.92893 13.0201C8.53841 13.4107 8.53841 14.0438 8.92893 14.4343C9.31946 14.8249 9.95262 14.8249 10.3431 14.4343L16.7071 8.07039ZM0 7.36328V8.36328H16V7.36328V6.36328H0V7.36328Z'
      fill='white'
    />
  </svg>
);
const WhiteArrowDiagonal = () => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.7405 0.939454C11.7071 0.388182 11.2331 -0.031617 10.6819 0.00180761L1.69835 0.546493C1.14708 0.579917 0.727284 1.05391 0.760709 1.60518C0.794133 2.15645 1.26812 2.57625 1.8194 2.54283L9.80473 2.05866L10.2889 10.044C10.3223 10.5953 10.7963 11.0151 11.3476 10.9816C11.8989 10.9482 12.3187 10.4742 12.2852 9.92296L11.7405 0.939454ZM1 12L1.74861 12.663L11.491 1.66299L10.7424 0.999975L9.99377 0.336958L0.251395 11.337L1 12Z'
      fill='white'
    />
  </svg>
);
const SearchFilter = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.75195 6.00001C6.75212 6.66523 6.53119 7.31164 6.12389 7.83759C5.7166 8.36354 5.14605 8.73921 4.50195 8.90551L4.50195 17.25C4.5023 17.4374 4.43246 17.6182 4.30619 17.7567C4.17992 17.8952 4.00637 17.9814 3.81972 17.9983C3.63307 18.0153 3.44684 17.9617 3.29771 17.8482C3.14857 17.7347 3.04734 17.5694 3.01395 17.385L3.00195 17.25L3.00045 8.90551C2.35581 8.73976 1.78459 8.36434 1.37672 7.83834C0.968852 7.31233 0.747494 6.66562 0.747494 6.00001C0.747494 5.3344 0.968852 4.68769 1.37672 4.16168C1.78459 3.63568 2.35581 3.26026 3.00045 3.09451L3.00195 0.750009C3.00161 0.56259 3.07145 0.381834 3.19772 0.243335C3.32398 0.104835 3.49753 0.0186303 3.68419 0.00169605C3.87084 -0.0152382 4.05707 0.0383253 4.2062 0.151839C4.35533 0.265352 4.45656 0.430588 4.48995 0.615009L4.50195 0.750009V3.09451C5.14605 3.26081 5.7166 3.63648 6.12389 4.16243C6.53119 4.68838 6.75212 5.33479 6.75195 6.00001ZM5.25195 6.00001C5.25195 5.60218 5.09392 5.22065 4.81261 4.93935C4.53131 4.65805 4.14978 4.50001 3.75195 4.50001C3.35413 4.50001 2.9726 4.65805 2.69129 4.93935C2.40999 5.22065 2.25195 5.60218 2.25195 6.00001C2.25195 6.39783 2.40999 6.77937 2.69129 7.06067C2.9726 7.34197 3.35413 7.50001 3.75195 7.50001C4.14978 7.50001 4.53131 7.34197 4.81261 7.06067C5.09392 6.77937 5.25195 6.39783 5.25195 6.00001ZM17.252 12C17.2521 12.6652 17.0312 13.3116 16.6239 13.8376C16.2166 14.3635 15.646 14.7392 15.002 14.9055V17.25C15.0023 17.4374 14.9325 17.6182 14.8062 17.7567C14.6799 17.8952 14.5064 17.9814 14.3197 17.9983C14.1331 18.0153 13.9468 17.9617 13.7977 17.8482C13.6486 17.7347 13.5473 17.5694 13.514 17.385L13.502 17.25L13.5005 14.9055C12.8558 14.7398 12.2846 14.3643 11.8767 13.8383C11.4689 13.3123 11.2475 12.6656 11.2475 12C11.2475 11.3344 11.4689 10.6877 11.8767 10.1617C12.2846 9.63568 12.8558 9.26026 13.5005 9.09451L13.502 0.750009C13.5016 0.56259 13.5714 0.381834 13.6977 0.243335C13.824 0.104835 13.9975 0.0186303 14.1842 0.00169605C14.3708 -0.0152382 14.5571 0.0383253 14.7062 0.151839C14.8553 0.265352 14.9566 0.430588 14.99 0.615009L15.002 0.750009V9.09451C15.646 9.26081 16.2166 9.63648 16.6239 10.1624C17.0312 10.6884 17.2521 11.3348 17.252 12ZM15.752 12C15.752 11.6022 15.5939 11.2207 15.3126 10.9394C15.0313 10.658 14.6498 10.5 14.252 10.5C13.8541 10.5 13.4726 10.658 13.1913 10.9394C12.91 11.2207 12.752 11.6022 12.752 12C12.752 12.3978 12.91 12.7794 13.1913 13.0607C13.4726 13.342 13.8541 13.5 14.252 13.5C14.6498 13.5 15.0313 13.342 15.3126 13.0607C15.5939 12.7794 15.752 12.3978 15.752 12Z'
      fill='black'
      fillOpacity='0.5'
    />
  </svg>
);
const ArrowRightBlack = () => (
  <svg
    width='20'
    height='18'
    viewBox='0 0 20 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.1855 9.72341C19.6446 9.2528 19.6353 8.49909 19.1647 8.03995L11.4956 0.557873C11.025 0.0987352 10.2713 0.108036 9.81219 0.578647C9.35305 1.04926 9.36235 1.80297 9.83296 2.26211L16.6499 8.91284L9.99916 15.7298C9.54002 16.2004 9.54933 16.9541 10.0199 17.4132C10.4905 17.8724 11.2443 17.8631 11.7034 17.3925L19.1855 9.72341ZM0.841797 9.10793L0.856487 10.2983L18.348 10.0825L18.3334 8.89207L18.3187 7.70168L0.827107 7.91754L0.841797 9.10793Z'
      fill='#1E1E1E'
    />
  </svg>
);
const GreenBgTick = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9055 1.01419C17.6672 0.633365 17.3161 0.336324 16.901 0.164413C16.486 -0.0074974 16.0277 -0.0457244 15.5899 0.0550546L12.4829 0.768788C12.1645 0.841978 11.8336 0.841978 11.5152 0.768788L8.40813 0.0550546C7.97035 -0.0457244 7.51204 -0.0074974 7.09701 0.164413C6.68197 0.336324 6.33085 0.633365 6.09253 1.01419L4.39904 3.71704C4.22623 3.99355 3.99294 4.22685 3.71645 4.4014L1.01378 6.095C0.633634 6.33313 0.337048 6.6837 0.165185 7.09805C-0.00667728 7.51241 -0.045291 7.96999 0.0547039 8.40729L0.768391 11.518C0.841312 11.8359 0.841312 12.1662 0.768391 12.484L0.0547039 15.593C-0.0456796 16.0306 -0.00726023 16.4885 0.164621 16.9032C0.336502 17.3179 0.633305 17.6688 1.01378 17.907L3.71645 19.6006C3.99294 19.7735 4.22623 20.0068 4.40076 20.2833L6.09426 22.9861C6.58157 23.7655 7.51127 24.1509 8.40813 23.9452L11.5152 23.2315C11.8336 23.1583 12.1645 23.1583 12.4829 23.2315L15.5917 23.9452C16.0292 24.0456 16.4871 24.0072 16.9018 23.8353C17.3165 23.6634 17.6673 23.3666 17.9055 22.9861L19.599 20.2833C19.7718 20.0068 20.0051 19.7735 20.2816 19.6006L22.986 17.907C23.3665 17.6685 23.6632 17.3172 23.8347 16.9022C24.0063 16.4871 24.0443 16.0289 23.9434 15.5913L23.2314 12.484C23.1582 12.1656 23.1582 11.8347 23.2314 11.5163L23.9451 8.40729C24.0456 7.96992 24.0075 7.51208 23.8359 7.09739C23.6643 6.6827 23.3679 6.33174 22.9877 6.09327L20.2833 4.39967C20.0072 4.22653 19.7739 3.99317 19.6007 3.71704L17.9055 1.01419ZM17.0363 8.14634C17.1432 7.94979 17.1697 7.71944 17.1102 7.50376C17.0507 7.28807 16.9099 7.10388 16.7173 6.98992C16.5248 6.87596 16.2956 6.84113 16.0779 6.89275C15.8602 6.94438 15.6711 7.07842 15.5502 7.2667L11.0313 14.9156L8.30272 12.3026C8.22177 12.2195 8.12491 12.1535 8.01792 12.1086C7.91092 12.0637 7.79599 12.0409 7.67997 12.0414C7.56395 12.0419 7.44922 12.0658 7.34262 12.1116C7.23602 12.1574 7.13974 12.2242 7.05952 12.308C6.9793 12.3918 6.91678 12.491 6.8757 12.5995C6.83461 12.708 6.8158 12.8236 6.82038 12.9396C6.82496 13.0555 6.85285 13.1694 6.90237 13.2743C6.95189 13.3792 7.02204 13.4731 7.10863 13.5503L10.6235 16.9185C10.7176 17.0085 10.8307 17.076 10.9546 17.1161C11.0784 17.1562 11.2097 17.1678 11.3386 17.15C11.4676 17.1322 11.5908 17.0855 11.6992 17.0134C11.8076 16.9413 11.8982 16.8457 11.9645 16.7336L17.0363 8.14634Z'
      fill='#009168'
    />
  </svg>
);
const DiscountBadge = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3892_21146)'>
      <circle cx='15.833' cy='15.832' r='2.5' fill='#C5ECE3' />
      <circle cx='24.167' cy='24.168' r='2.5' fill='#C5ECE3' />
      <path
        d='M15.528 38.9195C15.3335 38.92 15.1398 38.8951 14.9518 38.8454C13.908 38.5665 13.2664 37.593 12.6458 36.6514C12.3102 36.0379 11.8523 35.4998 11.3004 35.0703C10.6423 34.7993 9.93528 34.6671 9.22369 34.6822C8.10855 34.6141 6.9572 34.5411 6.20801 33.7935C5.45882 33.046 5.38747 31.8925 5.31882 30.7779C5.33317 30.067 5.20087 29.3608 4.93017 28.7033C4.50081 28.1509 3.96245 27.6928 3.34855 27.3573C2.40693 26.7368 1.43342 26.0952 1.15504 25.0514C0.884768 24.0503 1.39558 23.0303 1.88693 22.0433C2.26477 21.4195 2.50834 20.7238 2.60207 20.0006C2.50795 19.2781 2.2644 18.5832 1.88693 17.96C1.39558 16.9735 0.887471 15.953 1.15504 14.9519C1.43342 13.9081 2.40747 13.2665 3.34855 12.646C3.96241 12.3107 4.50076 11.8527 4.93017 11.3006C5.20096 10.6424 5.33308 9.93539 5.31828 9.22381C5.38747 8.10976 5.45828 6.95787 6.20747 6.20814C6.95666 5.45841 8.10855 5.3876 9.22315 5.31895C9.93403 5.33329 10.6403 5.20099 11.2977 4.9303C11.8503 4.50187 12.3091 3.96468 12.6458 3.35192C13.2664 2.4103 13.908 1.43679 14.9518 1.15787C15.9496 0.892464 16.9729 1.39841 17.9604 1.88976C18.5836 2.2663 19.2784 2.50893 20.0004 2.60219C20.7227 2.5081 21.4175 2.26455 22.0404 1.88706C23.028 1.39571 24.0513 0.889761 25.0491 1.15517C26.0929 1.43409 26.7345 2.4076 27.355 3.34922C27.6915 3.96296 28.1503 4.5011 28.7031 4.9303C29.3613 5.20134 30.0683 5.33347 30.7799 5.31841C31.894 5.38706 33.0464 5.45841 33.7956 6.2076C34.5448 6.95679 34.6134 8.10868 34.6821 9.22328C34.6677 9.93416 34.8 10.6404 35.0707 11.2979C35.5001 11.8502 36.0384 12.3083 36.6523 12.6438C37.594 13.2644 38.5675 13.906 38.8458 14.9498C39.1134 15.9508 38.6053 16.9708 38.114 17.9579C37.7361 18.5816 37.4925 19.2773 37.3988 20.0006C37.4929 20.723 37.7365 21.418 38.114 22.0411C38.6053 23.0281 39.1134 24.0481 38.8458 25.0492C38.5675 26.093 37.5934 26.7346 36.6523 27.3552C36.0382 27.6913 35.4998 28.1502 35.0707 28.7033C34.7999 29.3615 34.6678 30.0685 34.6826 30.78C34.6134 31.8941 34.5426 33.046 33.7934 33.7957C33.0442 34.5454 31.8923 34.6135 30.7777 34.6822C30.0661 34.6676 29.3591 34.7999 28.701 35.0708C28.1489 35.5003 27.6908 36.0384 27.355 36.6519C26.7345 37.5935 26.0929 38.5671 25.0491 38.846C24.0513 39.1119 23.028 38.6054 22.0404 38.1141C21.4175 37.7366 20.7227 37.493 20.0004 37.3989C19.2782 37.493 18.5834 37.7366 17.9604 38.1141C17.2199 38.5606 16.3887 38.8358 15.528 38.9195ZM15.528 2.16273C15.4272 2.16186 15.3267 2.17422 15.2291 2.19949C14.5804 2.37246 14.0561 3.17246 13.5458 3.94382C13.1289 4.70462 12.5458 5.36163 11.8399 5.86598C11.0402 6.23261 10.1682 6.41441 9.28855 6.39787C8.33288 6.45679 7.43071 6.51246 6.97017 6.97246C6.50963 7.43246 6.4545 8.33517 6.39558 9.29084C6.41231 10.1704 6.23069 11.0424 5.86423 11.8422C5.36098 12.5475 4.70552 13.1305 3.94639 13.5481C3.17342 14.0579 2.37504 14.5844 2.20153 15.2308C2.03936 15.8368 2.4372 16.6362 2.8572 17.4779C3.3191 18.2458 3.60145 19.1082 3.68315 20.0006C3.60063 20.8932 3.31735 21.7556 2.8545 22.5233C2.43288 23.3676 2.03774 24.1627 2.19882 24.7703C2.37234 25.419 3.1718 25.9433 3.94369 26.453C4.7044 26.8703 5.36137 27.4536 5.86585 28.1595C6.23248 28.9592 6.41428 29.8312 6.39774 30.7108C6.45666 31.6665 6.51234 32.5687 6.97234 33.0292C7.43234 33.4898 8.33504 33.5449 9.29071 33.6038C10.1703 33.5868 11.0424 33.7685 11.8421 34.1352C12.5478 34.6396 13.1309 35.2966 13.548 36.0573C14.0577 36.8298 14.5842 37.6287 15.2307 37.8017C15.8367 37.9638 16.6361 37.5671 17.4783 37.1465C18.2458 36.6836 19.108 36.4003 20.0004 36.3179C20.8929 36.4003 21.7551 36.6836 22.5226 37.1465C23.3669 37.5671 24.1653 37.9638 24.7702 37.8017C25.4188 37.6287 25.9431 36.8287 26.4534 36.0573C26.8703 35.2965 27.4535 34.6395 28.1594 34.1352C28.9591 33.7685 29.8311 33.5867 30.7107 33.6033C31.6664 33.5444 32.5686 33.4887 33.0291 33.0287C33.4896 32.5687 33.5448 31.666 33.6037 30.7103C33.587 29.8307 33.7686 28.9587 34.135 28.159C34.6395 27.4532 35.2965 26.8701 36.0572 26.453C36.8302 25.9433 37.6286 25.4168 37.8021 24.7703C37.9642 24.1644 37.5664 23.3649 37.1464 22.5233C36.6835 21.7556 36.4003 20.8932 36.3177 20.0006C36.4003 19.108 36.6835 18.2456 37.1464 17.4779C37.5664 16.6335 37.9631 15.8368 37.8021 15.2308C37.6286 14.5822 36.8291 14.0579 36.0572 13.5481C35.2965 13.1308 34.6395 12.5476 34.135 11.8417C33.7684 11.0419 33.5866 10.1699 33.6031 9.2903C33.5442 8.33463 33.4886 7.43246 33.0286 6.97192C32.5686 6.51138 31.6658 6.45625 30.7102 6.39733C29.8306 6.41432 28.9585 6.23269 28.1588 5.86598C27.4533 5.36227 26.8703 4.70624 26.4529 3.94652C25.9431 3.17409 25.4167 2.37517 24.7702 2.20219C24.1648 2.04003 23.3675 2.43679 22.5226 2.85733C21.7549 3.31927 20.8927 3.60163 20.0004 3.68327C19.108 3.6008 18.2458 3.31752 17.4783 2.85463C16.8834 2.49216 16.2199 2.2566 15.5296 2.16273H15.528Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M24.3094 27.5855C23.7892 27.5858 23.2771 27.456 22.8199 27.2079C22.3626 26.9598 21.9747 26.6012 21.6914 26.1649C21.4081 25.7285 21.2385 25.2282 21.198 24.7096C21.1574 24.1909 21.2473 23.6704 21.4593 23.1953C21.6714 22.7202 21.9989 22.3058 22.412 21.9896C22.8252 21.6735 23.3109 21.4657 23.8249 21.3852C24.3388 21.3047 24.8648 21.3541 25.3548 21.5288C25.8448 21.7035 26.2834 21.998 26.6305 22.3855C27.033 22.8337 27.297 23.389 27.3905 23.9841C27.4841 24.5792 27.4032 25.1887 27.1576 25.7388C26.9121 26.2889 26.5124 26.7561 26.0069 27.0838C25.5014 27.4116 24.9118 27.5858 24.3094 27.5855ZM24.3094 22.4304C23.8429 22.4308 23.3906 22.5914 23.0283 22.8852C22.6659 23.179 22.4153 23.5883 22.3185 24.0446C22.2216 24.501 22.2843 24.9768 22.4961 25.3925C22.7078 25.8081 23.0559 26.1386 23.482 26.3285C23.9081 26.5184 24.3865 26.5563 24.8372 26.4359C25.2879 26.3155 25.6837 26.0441 25.9583 25.6669C26.2329 25.2898 26.3698 24.8299 26.346 24.3639C26.3223 23.898 26.1393 23.4544 25.8278 23.1071C25.6366 22.8932 25.4022 22.7223 25.1401 22.6056C24.878 22.489 24.5941 22.4292 24.3072 22.4304H24.3094Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M15.6932 18.6519C15.173 18.6522 14.6609 18.5224 14.2036 18.2743C13.7464 18.0262 13.3585 17.6676 13.0752 17.2313C12.7919 16.7949 12.6223 16.2946 12.5817 15.776C12.5412 15.2573 12.6311 14.7368 12.8431 14.2617C13.0552 13.7867 13.3827 13.3722 13.7958 13.056C14.209 12.7399 14.6947 12.5321 15.2086 12.4516C15.7226 12.3711 16.2486 12.4205 16.7386 12.5952C17.2286 12.7699 17.6672 13.0644 18.0143 13.4519C18.4168 13.9001 18.6807 14.4554 18.7743 15.0505C18.8678 15.6456 18.787 16.2551 18.5414 16.8052C18.2959 17.3553 17.8962 17.8225 17.3907 18.1502C16.8852 18.478 16.2956 18.6522 15.6932 18.6519ZM15.6932 13.4968C15.2267 13.4973 14.7745 13.658 14.4122 13.9519C14.0499 14.2458 13.7995 14.6551 13.7027 15.1114C13.6059 15.5678 13.6687 16.0435 13.8806 16.4592C14.0924 16.8748 14.4404 17.2051 14.8666 17.395C15.2927 17.5849 15.771 17.6227 16.2217 17.5023C16.6724 17.3818 17.0681 17.1104 17.3427 16.7332C17.6173 16.3561 17.7541 15.8962 17.7304 15.4303C17.7066 14.9644 17.5237 14.5208 17.2121 14.1735C17.0206 13.9599 16.786 13.7892 16.5239 13.6726C16.2618 13.556 15.9779 13.496 15.691 13.4968H15.6932Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
      <path
        d='M12.7965 27.5599C12.6889 27.5601 12.5837 27.5282 12.4943 27.4683C12.405 27.4083 12.3356 27.3231 12.2949 27.2235C12.2543 27.1239 12.2443 27.0144 12.2662 26.9091C12.2882 26.8038 12.341 26.7074 12.4181 26.6323L26.8267 12.5956C26.9294 12.4952 27.0678 12.4398 27.2114 12.4414C27.355 12.4431 27.492 12.5018 27.5924 12.6045C27.6928 12.7072 27.7482 12.8456 27.7465 12.9892C27.7448 13.1328 27.6862 13.2698 27.5835 13.3702L13.1737 27.4064C13.0728 27.5048 12.9374 27.5599 12.7965 27.5599Z'
        fill='black'
        stroke='black'
        strokeWidth='0.3'
      />
    </g>
    <defs>
      <clipPath id='clip0_3892_21146'>
        <rect width='40' height='40' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const DocNote = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.44434 33.7487H9.44434V6.2487H16.5277L31.111 5.41536L30.2777 0.832031L4.44434 1.2487V33.7487Z'
      fill='#C5ECE3'
    />
    <path
      d='M5.06055 0.0996094H29.6396C30.644 0.0998727 31.4669 0.922813 31.4668 1.92773V5.40137H34.9404C35.9452 5.40163 36.7675 6.22448 36.7676 7.22949L36.7666 30.3613C36.7666 30.8739 36.6131 31.4908 36.3623 32.0713C36.1115 32.6517 35.7679 33.1861 35.3945 33.5371L30.0098 38.6064C29.6359 38.9583 29.0796 39.2821 28.4834 39.5186C27.8873 39.7549 27.2605 39.9003 26.7471 39.9004H10.3613C9.35608 39.9001 8.53418 39.0771 8.53418 38.0723V34.5986H5.06055C4.05562 34.5986 3.23267 33.7763 3.23242 32.7715V1.92773C3.23242 0.92265 4.05555 0.0996094 5.06055 0.0996094ZM10.3613 6.64746C10.0447 6.64763 9.77951 6.91244 9.7793 7.22852V38.0723C9.77934 38.3885 10.0445 38.6541 10.3613 38.6543H26.7471C26.9006 38.6543 27.0736 38.629 27.248 38.5938L27.3281 38.5771V33.4941C27.331 32.0867 28.4716 30.9464 29.8789 30.9434H35.4355L35.4531 30.8652C35.4932 30.6893 35.5205 30.5152 35.5205 30.3613L35.5215 7.22852C35.5213 6.91228 35.2557 6.64746 34.9395 6.64746H10.3613ZM29.8789 32.1895C29.5201 32.1895 29.1977 32.3348 28.958 32.5723L28.957 32.5732C28.7194 32.8125 28.5742 33.1353 28.5742 33.4941V38.1064L28.7266 38.0137C28.8879 37.9152 29.038 37.8094 29.1553 37.6992L34.541 32.6299C34.6247 32.5508 34.7052 32.452 34.7812 32.3486L34.8984 32.1895H29.8789ZM5.06055 1.3457C4.74415 1.3457 4.47852 1.61133 4.47852 1.92773V32.7715C4.47872 33.0877 4.74427 33.3525 5.06055 33.3525H8.53418V7.22852C8.53443 6.22373 9.35616 5.40153 10.3613 5.40137H30.2207V1.92773C30.2207 1.61141 29.9553 1.34593 29.6396 1.3457H5.06055Z'
      fill='black'
      stroke='white'
      strokeWidth='0.2'
    />
    <path
      d='M15.6631 12.1973H29.6387C29.9549 12.1973 30.2118 12.453 30.2119 12.7695C30.2119 13.0862 29.955 13.3428 29.6387 13.3428H15.6631C15.3466 13.3426 15.0908 13.0861 15.0908 12.7695C15.0909 12.453 15.3466 12.1974 15.6631 12.1973Z'
      fill='black'
      stroke='white'
      strokeWidth='0.3'
    />
    <path
      d='M15.6631 21.8379H29.6387C29.9549 21.8379 30.2118 22.0936 30.2119 22.4102C30.2119 22.7268 29.955 22.9834 29.6387 22.9834H15.6631C15.3466 22.9833 15.0908 22.7268 15.0908 22.4102C15.0909 22.0937 15.3466 21.838 15.6631 21.8379Z'
      fill='black'
      stroke='white'
      strokeWidth='0.3'
    />
    <path
      d='M15.6631 26.6582H23.374C23.6901 26.6582 23.9462 26.9138 23.9463 27.2305C23.9463 27.5472 23.6902 27.8037 23.374 27.8037H15.6631C15.3465 27.8036 15.0908 27.5471 15.0908 27.2305C15.0909 26.914 15.3466 26.6583 15.6631 26.6582Z'
      fill='black'
      stroke='white'
      strokeWidth='0.3'
    />
    <path
      d='M15.6631 17.0176H29.6387C29.9549 17.0176 30.2118 17.2733 30.2119 17.5898C30.2119 17.9065 29.955 18.1631 29.6387 18.1631H15.6631C15.3466 18.163 15.0908 17.9064 15.0908 17.5898C15.0909 17.2733 15.3466 17.0177 15.6631 17.0176Z'
      fill='black'
      stroke='white'
      strokeWidth='0.3'
    />
  </svg>
);
const Auth = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3892_21266)'>
      <path
        d='M23.0557 25.418L30.139 22.918L33.0557 24.5846L36.8057 25.418V32.0846L33.4723 37.0846L29.7223 39.168L26.389 36.668L23.0557 32.0846V25.418Z'
        fill='#C5ECE3'
      />
      <path
        d='M11.2588 7.78906H12.708C13.5324 7.78906 14.2031 8.45908 14.2031 9.28125V10.1582H15.082C15.9057 10.1583 16.576 10.829 16.5762 11.6523V13.1035C16.576 13.9269 15.9058 14.5975 15.082 14.5977H14.2031V15.4746C14.2031 16.2985 13.5323 16.9688 12.708 16.9688H11.2588C10.4346 16.9687 9.76465 16.2985 9.76465 15.4746V14.5977H8.88574C8.06156 14.5977 7.39078 13.9269 7.39062 13.1035V11.6523C7.39083 10.8289 8.06162 10.1582 8.88574 10.1582H9.76465V9.28125C9.76465 8.45907 10.4344 7.7891 11.2588 7.78906ZM11.2588 9.10352C11.2077 9.10354 11.1637 9.12489 11.1338 9.15332C11.1042 9.18152 11.0781 9.22658 11.0781 9.28125V10.8154C11.0781 11.1782 10.7838 11.4727 10.4209 11.4727H8.88574C8.78885 11.4727 8.70529 11.5532 8.70508 11.6523V13.1035C8.70524 13.2029 8.78927 13.2832 8.88574 13.2832H10.4209C10.7837 13.2832 11.0781 13.5776 11.0781 13.9404V15.4746C11.0781 15.5735 11.1617 15.6552 11.2588 15.6553H12.708C12.805 15.6553 12.8887 15.5739 12.8887 15.4746V13.9404C12.8887 13.5776 13.1832 13.2832 13.5459 13.2832H15.0811C15.1775 13.2832 15.2625 13.2029 15.2627 13.1035V11.6523C15.2625 11.5532 15.1779 11.4727 15.0811 11.4727H13.5459C13.1831 11.4727 12.8887 11.1782 12.8887 10.8154V9.28125C12.8887 9.22617 12.8626 9.1813 12.833 9.15332C12.8031 9.12507 12.759 9.10352 12.708 9.10352H11.2588Z'
        fill='black'
        stroke='white'
        strokeWidth='0.25'
      />
      <path
        d='M8.57324 20.2734H26.4775C26.8402 20.2736 27.1338 20.568 27.1338 20.9307C27.1336 21.2933 26.84 21.5877 26.4775 21.5879H8.57324C8.21057 21.5879 7.91621 21.2933 7.91602 20.9307C7.91602 20.5679 8.21039 20.2734 8.57324 20.2734Z'
        fill='black'
        stroke='white'
        strokeWidth='0.25'
      />
      <path
        d='M11.3076 0.046875H23.6182C24.3422 0.046875 24.9316 0.635359 24.9316 1.35742V1.77441H28.7881C30.8111 1.77441 32.457 3.41813 32.457 5.43848V10.459C32.4569 10.8217 32.1624 11.1162 31.7998 11.1162C31.4374 11.1159 31.1437 10.8215 31.1436 10.459V5.43848C31.1435 4.14211 30.0864 3.08789 28.7881 3.08789H24.9316V3.50293C24.9316 4.22499 24.3422 4.81348 23.6182 4.81348H11.3076C10.5836 4.81343 9.99512 4.22497 9.99512 3.50293V3.08789H6.1377C4.83935 3.08789 3.78324 4.14214 3.7832 5.43848V34.2646C3.78323 35.561 4.83934 36.6152 6.1377 36.6152H25.3008L25.1055 36.4053C23.6673 34.8597 22.7881 33.1785 22.4746 31.3848L22.4199 31.0244C22.4191 30.8068 22.4022 30.5478 22.3857 30.2852C22.3687 30.0135 22.3531 29.7353 22.3584 29.4795V26.252H8.57324C8.21039 26.252 7.91602 25.9575 7.91602 25.5947C7.91608 25.2321 8.21043 24.9375 8.57324 24.9375H22.5469L22.583 24.9072C22.6747 24.8266 22.7883 24.7705 22.916 24.751H22.917C24.5668 24.4994 25.9464 24.1695 27.0459 23.7637C28.144 23.3583 28.9713 22.8737 29.5078 22.3066C29.6316 22.1757 29.8048 22.1006 29.9854 22.1006C30.1657 22.1007 30.3378 22.1757 30.4619 22.3066C30.6024 22.4554 30.7633 22.5976 30.9424 22.7344L31.1436 22.8877V16.6973C31.1436 16.3342 31.4371 16.0401 31.7998 16.04C32.1629 16.04 32.457 16.3342 32.457 16.6973V23.5801L32.5342 23.6113C33.6909 24.0877 35.2018 24.4685 37.0518 24.751C37.3726 24.8001 37.6091 25.0758 37.6094 25.4004V30.3604L37.6084 30.3984C37.4564 33.0068 36.1564 35.3966 33.7256 37.501C32.8563 38.2527 32.1907 38.8281 31.6016 39.2168C31.0153 39.6035 30.5169 39.7968 29.9834 39.7969H29.9805C29.506 39.7963 29.0586 39.6421 28.5518 39.334C28.0423 39.0242 27.48 38.5635 26.7754 37.959L26.7402 37.9287H6.1377C4.11463 37.9287 2.46878 36.285 2.46875 34.2646V5.43848C2.46879 3.41814 4.11494 1.77441 6.1377 1.77441H9.99512V1.35742C9.99512 0.635386 10.5836 0.0469174 11.3076 0.046875ZM11.3086 3.49902H23.6172V1.36133H11.3086V3.49902ZM36.2959 25.96L36.1924 25.9424C34.5283 25.6555 33.1485 25.2847 32.0361 24.8262L31.5762 24.624L31.5674 24.6211L31.4746 24.5771L31.4658 24.5732L31.0732 24.3721C30.6944 24.1668 30.3579 23.9479 30.0625 23.7148L29.9854 23.6533L29.9072 23.7148C28.6418 24.7142 26.6285 25.4511 23.7764 25.9424L23.6719 25.96V30.3369L23.6729 30.3447C23.8128 32.5905 24.9747 34.663 27.1045 36.5068C27.8036 37.1117 28.3697 37.6021 28.8301 37.9404C29.0604 38.1097 29.2683 38.2436 29.4561 38.3359C29.6431 38.4278 29.8186 38.4832 29.9824 38.4834C30.148 38.4834 30.3279 38.4258 30.5186 38.3311C30.7105 38.2356 30.9235 38.0967 31.1572 37.9248C31.6241 37.5813 32.1908 37.0912 32.8662 36.5068C34.9959 34.663 36.1578 32.5899 36.2959 30.3447V25.96Z'
        fill='black'
        stroke='white'
        strokeWidth='0.25'
      />
      <path
        d='M32.5938 28.0391C32.8378 27.7706 33.254 27.7508 33.5225 27.9951C33.7909 28.2392 33.8107 28.6554 33.5664 28.9238L29.6016 33.2812V33.2822C29.5127 33.3798 29.3968 33.4469 29.2705 33.4775L29.1416 33.4961C29.1315 33.4964 29.1231 33.4971 29.1152 33.4971C28.9487 33.497 28.788 33.4329 28.666 33.3184L26.7109 31.4854C26.4465 31.2369 26.4335 30.8211 26.6816 30.5566C26.9297 30.292 27.3457 30.2784 27.6104 30.5264L28.9863 31.8174L29.0781 31.9043L29.1641 31.8096L32.5938 28.0391Z'
        fill='black'
        stroke='white'
        strokeWidth='0.25'
      />
      <path d='M31.8057 17.0833V8.75' stroke='black' strokeWidth='1.08333' />
    </g>
    <defs>
      <clipPath id='clip0_3892_21266'>
        <rect width='40' height='40' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const PatientSupport = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M6.25 35.832V32.082H33.75V35.832H6.25Z' fill='#C5ECE3' />
    <path
      d='M20 8.40332C21.5227 8.40332 23.0307 8.70246 24.4375 9.28516C25.8442 9.86784 27.1225 10.7222 28.1992 11.7988C29.276 12.8756 30.1301 14.1547 30.7129 15.5615C31.2956 16.9683 31.5957 18.4763 31.5957 19.999V30.9033H32.5C33.1443 30.9033 33.7622 31.1587 34.2178 31.6143C34.6733 32.0698 34.9287 32.6878 34.9287 33.332V34.165C34.9287 34.8092 34.6732 35.4273 34.2178 35.8828C33.7622 36.3384 33.1443 36.5947 32.5 36.5947H7.5C6.85575 36.5947 6.23778 36.3384 5.78223 35.8828C5.32677 35.4273 5.07129 34.8092 5.07129 34.165V33.332C5.07129 32.6878 5.32667 32.0698 5.78223 31.6143C6.23778 31.1587 6.85575 30.9033 7.5 30.9033H8.4043V19.999C8.4043 18.4763 8.70442 16.9683 9.28711 15.5615C9.86985 14.1547 10.724 12.8756 11.8008 11.7988C12.8775 10.7222 14.1558 9.86784 15.5625 9.28516C16.9693 8.70246 18.4773 8.40332 20 8.40332ZM7.5 32.4277C7.2602 32.4277 7.02992 32.5228 6.86035 32.6924C6.69079 32.8619 6.5957 33.0922 6.5957 33.332V34.165C6.5957 34.4048 6.69089 34.6351 6.86035 34.8047C7.02992 34.9743 7.2602 35.0693 7.5 35.0693H32.5C32.7398 35.0693 32.9701 34.9743 33.1396 34.8047C33.3091 34.6351 33.4043 34.4048 33.4043 34.165V33.332C33.4043 33.0922 33.3092 32.8619 33.1396 32.6924C32.9701 32.5228 32.7398 32.4277 32.5 32.4277H7.5ZM20 9.92773C17.329 9.92773 14.7676 10.9893 12.8789 12.8779C10.9904 14.7666 9.92871 17.3281 9.92871 19.999V30.9033H30.0713V19.999C30.0713 17.3281 29.0096 14.7666 27.1211 12.8779C25.2324 10.9893 22.671 9.92773 20 9.92773Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M18.334 15.9033H21.667C21.8691 15.9033 22.0631 15.9831 22.2061 16.126C22.349 16.2689 22.4296 16.4629 22.4297 16.665V19.2363H25C25.2022 19.2363 25.3961 19.317 25.5391 19.46C25.6821 19.603 25.7627 19.7968 25.7627 19.999V23.332C25.7627 23.5343 25.6821 23.7281 25.5391 23.8711C25.3961 24.014 25.2022 24.0947 25 24.0947H22.4297V26.665C22.4297 26.8672 22.3489 27.0611 22.2061 27.2041C22.0631 27.3471 21.8692 27.4277 21.667 27.4277H18.334C18.1318 27.4277 17.9379 27.3471 17.7949 27.2041C17.6519 27.0611 17.5713 26.8673 17.5713 26.665V24.0947H15C14.7979 24.0946 14.6039 24.014 14.4609 23.8711C14.318 23.7281 14.2383 23.5342 14.2383 23.332V19.999C14.2383 19.7969 14.3181 19.6029 14.4609 19.46C14.6039 19.317 14.7979 19.2364 15 19.2363H17.5713V16.665C17.5714 16.4629 17.652 16.2689 17.7949 16.126C17.9379 15.9832 18.1319 15.9033 18.334 15.9033ZM19.0957 19.999C19.0956 20.2011 19.016 20.3952 18.873 20.5381C18.7301 20.681 18.5361 20.7607 18.334 20.7607H15.7627V22.5693H18.334C18.5361 22.5694 18.7301 22.65 18.873 22.793C19.0159 22.9359 19.0957 23.1299 19.0957 23.332V25.9033H20.9043V23.332C20.9043 23.1298 20.9849 22.936 21.1279 22.793C21.2709 22.65 21.4648 22.5693 21.667 22.5693H24.2383V20.7607H21.667C21.4648 20.7607 21.2709 20.681 21.1279 20.5381C20.985 20.3952 20.9044 20.2011 20.9043 19.999V17.4277H19.0957V19.999Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M20 1.73926C20.2021 1.73926 20.3961 1.81912 20.5391 1.96191C20.682 2.10483 20.7626 2.29887 20.7627 2.50098V5.83496C20.7626 6.03707 20.682 6.2311 20.5391 6.37402C20.3961 6.51682 20.2021 6.59668 20 6.59668C19.7979 6.59659 19.6039 6.51694 19.4609 6.37402C19.318 6.2311 19.2384 6.03707 19.2383 5.83496V2.50098C19.2384 2.29887 19.318 2.10483 19.4609 1.96191C19.6039 1.81899 19.7979 1.73934 20 1.73926Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M11.8203 4.29297C11.9642 4.31742 12.0973 4.38194 12.2041 4.47852L12.3018 4.58594L13.9658 7.08203C14.0413 7.19662 14.0845 7.32974 14.0908 7.4668C14.097 7.60382 14.0666 7.74038 14.002 7.86133C13.9371 7.98238 13.8403 8.08442 13.7227 8.15527C13.6051 8.226 13.4702 8.26296 13.333 8.26367C13.2085 8.26377 13.0857 8.23406 12.9756 8.17578C12.8929 8.13196 12.819 8.07304 12.7578 8.00293L12.7012 7.92871L11.0342 5.42871C10.9367 5.26169 10.9063 5.06369 10.9492 4.875C10.9925 4.68502 11.1066 4.51848 11.2686 4.41016C11.4306 4.30182 11.6282 4.26033 11.8203 4.29297Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M5.66406 10.0547C5.76618 10.0374 5.87103 10.041 5.97168 10.0654C6.07229 10.0899 6.16725 10.134 6.25 10.1963L6.25293 10.1992L8.75293 11.8652C8.88811 11.9561 8.99101 12.0879 9.0459 12.2412C9.10078 12.3946 9.1045 12.5618 9.05762 12.7178C9.01075 12.8737 8.91539 13.0107 8.78516 13.1084C8.65481 13.2061 8.49591 13.2585 8.33301 13.2598C8.18126 13.26 8.03321 13.2155 7.90723 13.1309H7.90625L5.40625 11.4648V11.4639L5.40332 11.4619L5.33887 11.4199C5.27656 11.374 5.22163 11.3186 5.17578 11.2559C5.11474 11.1722 5.07088 11.0766 5.04785 10.9756C5.02484 10.8745 5.02314 10.769 5.04199 10.667C5.06088 10.5652 5.09967 10.4679 5.15723 10.3818C5.21486 10.2957 5.28996 10.2224 5.37695 10.166C5.46395 10.1097 5.56189 10.072 5.66406 10.0547Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M28.1797 4.28125C28.3718 4.24862 28.5694 4.29016 28.7314 4.39844C28.8934 4.50675 29.0075 4.6733 29.0508 4.86328C29.0937 5.05202 29.0634 5.24994 28.9658 5.41699L27.2998 7.91699H27.2988L27.2969 7.9209C27.2442 8.00986 27.1743 8.08746 27.0908 8.14844C27.0071 8.20949 26.9115 8.25334 26.8105 8.27637C26.7094 8.29937 26.6039 8.30108 26.502 8.28223C26.4001 8.26335 26.3029 8.22358 26.2168 8.16602C26.1308 8.10843 26.0573 8.03412 26.001 7.94727C25.9446 7.86024 25.907 7.76239 25.8896 7.66016C25.8723 7.55793 25.8759 7.45329 25.9004 7.35254C25.9187 7.27704 25.9483 7.20494 25.9883 7.13867L26.0312 7.07422L26.0342 7.07129L27.6982 4.57422C27.8153 4.41853 27.9877 4.31395 28.1797 4.28125Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
    <path
      d='M34.0215 10.0654C34.1222 10.041 34.2269 10.0373 34.3291 10.0547C34.4313 10.0721 34.5292 10.1096 34.6162 10.166C34.7031 10.2223 34.7774 10.2958 34.835 10.3818C34.8925 10.4679 34.9323 10.5652 34.9512 10.667C34.97 10.769 34.9683 10.8745 34.9453 10.9756C34.9223 11.0766 34.8784 11.1722 34.8174 11.2559C34.7564 11.3393 34.6788 11.4092 34.5898 11.4619L34.5859 11.4648L32.0859 13.1309C31.962 13.2142 31.8164 13.2595 31.667 13.2607L31.5459 13.251C31.426 13.2319 31.3116 13.185 31.2129 13.1123C31.0814 13.0152 30.9844 12.878 30.9365 12.7217C30.8887 12.5653 30.8926 12.3973 30.9473 12.2432C31.002 12.0891 31.1046 11.9564 31.2402 11.8652L33.7402 10.1992L33.7432 10.1963C33.826 10.134 33.9208 10.0899 34.0215 10.0654Z'
      fill='black'
      stroke='white'
      strokeWidth='0.141667'
    />
  </svg>
);
const NurseCap = () => (
  <svg
    width='46'
    height='40'
    viewBox='0 0 46 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.45996 8.57236V18.0962L14.6028 14.2866L20.7933 12.3819H27.46L38.4123 18.0962V8.57236L35.5552 6.19141H10.3171L7.45996 8.57236Z'
      fill='#C5ECE3'
    />
    <path
      d='M11.4141 5.22949H34.2998C35.6206 5.23058 36.8872 5.75566 37.8213 6.68945C38.7554 7.62333 39.2808 8.89006 39.2822 10.2109V17.7217L39.3672 17.7783C41.2058 19.0129 42.9812 20.3391 44.6865 21.752V21.7529C44.9234 21.9541 45.0847 22.23 45.1436 22.5352C45.2021 22.8392 45.1547 23.1536 45.0107 23.4277L38.6738 34.0742L38.6709 34.0791C38.5529 34.2902 38.3801 34.4656 38.1709 34.5869C37.9618 34.7081 37.7241 34.7709 37.4824 34.7686H9.12305C8.89308 34.7696 8.66607 34.7131 8.46387 34.6035C8.26168 34.4939 8.0905 34.3348 7.96582 34.1416L7.95996 34.1328L0.794922 24.3223C0.604055 24.0471 0.519811 23.7116 0.557617 23.3789C0.595445 23.0465 0.752677 22.7389 1 22.5137C1.32291 22.2248 2.98506 20.7607 5.39258 18.9971L5.39355 18.9961C5.71824 18.7558 6.01804 18.5658 6.35156 18.3301L6.43164 18.2734V10.2109C6.4331 8.89013 6.95854 7.62331 7.89258 6.68945C8.8266 5.75569 10.0933 5.2307 11.4141 5.22949ZM23.2949 13.0898C20.9772 13.1727 18.695 13.6754 16.5586 14.5713L16.1338 14.7549C12.9048 16.1642 9.84084 17.9235 6.99707 20.001L6.43164 20.4209C4.61181 21.754 3.23677 22.9041 2.5791 23.4785L2.44727 23.5928L2.55078 23.7344L9.26465 32.9375L9.32227 33.0156H37.2598L37.3154 32.9219L43.2051 23.0312L43.2891 22.8896L43.1621 22.7852C41.3339 21.2983 39.4273 19.9107 37.4512 18.6279L36.5996 18.085C34.5107 16.7512 32.3105 15.5988 30.0244 14.6416C28.0367 13.7634 25.9098 13.2463 23.7432 13.1123L23.3086 13.0898H23.2949ZM11.4141 6.99121C10.5607 6.99204 9.74232 7.33136 9.13867 7.93457C8.53503 8.53793 8.19561 9.35649 8.19434 10.21V10.2109L8.19922 16.7188L8.2002 17.0723L8.49512 16.8779C10.7027 15.4229 13.0351 14.1665 15.4648 13.124L15.4678 13.123C17.9379 12.0228 20.5981 11.4121 23.3008 11.3262C25.8453 11.4118 28.3502 11.982 30.6816 13.0049L30.6855 13.0059C32.9566 13.956 35.145 15.0929 37.2285 16.4043L37.5205 16.5879V10.21C37.5192 9.35649 37.1798 8.53793 36.5762 7.93457C35.9725 7.3312 35.1533 6.99201 34.2998 6.99121H11.4141Z'
      fill='black'
      stroke='white'
      strokeWidth='0.380952'
    />
    <path
      d='M22.8574 20.2607C23.091 20.2607 23.3153 20.3534 23.4805 20.5186C23.6456 20.6837 23.7382 20.908 23.7383 21.1416V22.7764H25.3789C25.6125 22.7764 25.8368 22.8691 26.002 23.0342C26.1671 23.1993 26.2597 23.4237 26.2598 23.6572C26.2598 23.8908 26.1671 24.1151 26.002 24.2803C25.8367 24.4455 25.6125 24.5381 25.3789 24.5381H23.7383V26.1787C23.7383 26.4123 23.6457 26.6366 23.4805 26.8018C23.3153 26.967 23.0911 27.0596 22.8574 27.0596C22.6238 27.0595 22.3996 26.9669 22.2344 26.8018C22.0692 26.6366 21.9766 26.4123 21.9766 26.1787V24.5381H20.2354C20.0388 24.5155 19.8542 24.4274 19.7129 24.2861C19.5477 24.1209 19.4551 23.8967 19.4551 23.6631C19.4551 23.4295 19.5477 23.2052 19.7129 23.04C19.8781 22.8749 20.1023 22.7823 20.3359 22.7822H21.9766V21.1416C21.9766 20.908 22.0692 20.6837 22.2344 20.5186C22.3996 20.3534 22.6238 20.2608 22.8574 20.2607Z'
      fill='black'
      stroke='white'
      strokeWidth='0.380952'
    />
  </svg>
);
const Pills = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.3066 27.0833L6.80664 20.4167L12.2233 11.25L14.7233 9.16667L18.89 8.75L22.64 10.4167L24.7233 14.1667L24.3066 17.9167L19.3066 27.0833Z'
      fill='#C5ECE3'
    />
    <path
      d='M8.78833 39.4451C7.50225 39.4451 6.23137 39.1211 5.0744 38.4831C3.26934 37.4882 1.95795 35.8502 1.3858 33.8705C0.813645 31.8907 1.04402 29.8046 2.03896 27.9996L10.8111 12.0781C11.806 10.2705 13.444 8.9616 15.4238 8.38692C17.4035 7.81223 19.4896 8.04515 21.2947 9.04008C23.0997 10.035 24.4111 11.673 24.9833 13.6527C25.5579 15.635 25.325 17.7211 24.3301 19.5262L15.5605 35.4477C14.5655 37.2527 12.9276 38.5641 10.9478 39.1363C10.2339 39.3439 9.50985 39.4451 8.78833 39.4451ZM17.5807 9.29831C15.2845 9.29831 13.0567 10.5135 11.8744 12.6629L3.10225 28.5844C1.37314 31.7262 2.51997 35.6882 5.65921 37.4173C6.65162 37.9641 7.72757 38.2224 8.7858 38.2224C11.082 38.2224 13.3098 37.0072 14.4921 34.8578L23.2668 18.9388C24.9959 15.797 23.8491 11.835 20.7098 10.1059C19.7174 9.55907 18.6415 9.29831 17.5807 9.29831Z'
      fill='black'
    />
    <path
      d='M6.63884 36.2501C6.54011 36.2501 6.43884 36.2248 6.34517 36.1742C3.89201 34.8223 2.99327 31.7261 4.34517 29.2704L6.10467 26.0755C6.26669 25.7818 6.63631 25.6755 6.92998 25.8375C7.22365 25.9995 7.32998 26.3691 7.16796 26.6628L5.40846 29.8577C4.38061 31.7261 5.06163 34.0805 6.92998 35.1109C7.22365 35.2729 7.32998 35.6425 7.16796 35.9362C7.06163 36.1362 6.85403 36.2501 6.63884 36.2501Z'
      fill='black'
    />
    <path
      d='M19.4137 27.801C19.315 27.801 19.2137 27.7756 19.12 27.725L6.66433 20.8617C6.37066 20.6997 6.26433 20.3301 6.42635 20.0364C6.58838 19.7427 6.958 19.6364 7.25167 19.7984L19.7074 26.6617C20.001 26.8237 20.1074 27.1934 19.9453 27.487C19.8339 27.687 19.6264 27.801 19.4137 27.801Z'
      fill='black'
    />
    <path
      d='M31.2007 32.78C30.2032 32.78 29.2083 32.5851 28.2589 32.1927C26.3526 31.4079 24.8665 29.9243 24.0741 28.023L21.6842 22.2813C21.5551 21.9724 21.7019 21.6154 22.0108 21.4863C22.3196 21.3572 22.6766 21.5041 22.8057 21.8129L25.1956 27.5547C26.5753 30.8661 30.388 32.4408 33.6994 31.061C37.0108 29.6838 38.5829 25.8711 37.2057 22.5597L33.7146 14.1673L30.2234 5.77747C29.2108 3.34203 26.8513 1.76988 24.2158 1.76988C23.3576 1.76988 22.5196 1.9395 21.7196 2.27114C19.1627 3.33443 17.5576 5.90405 17.7247 8.66608C17.745 9.00026 17.4893 9.28886 17.1551 9.30912C16.8209 9.32937 16.5323 9.07367 16.5121 8.7395C16.3146 5.46102 18.2209 2.41038 21.2538 1.14962C22.2007 0.754687 23.1981 0.554688 24.2158 0.554688C25.7222 0.554688 27.1855 0.992662 28.4513 1.82051C29.7475 2.66861 30.7475 3.87621 31.345 5.31165L34.8361 13.7015L38.3272 22.0939C39.1196 23.9977 39.1222 26.0965 38.3374 28.0003C37.5526 29.9041 36.069 31.3927 34.1677 32.1851C33.2108 32.5825 32.2057 32.78 31.2007 32.78Z'
      fill='black'
    />
    <path
      d='M31.2081 30.1388C29.2157 30.1388 27.322 28.9591 26.5094 27.0097L25.1094 23.6426C24.9803 23.3337 25.1271 22.9768 25.436 22.8477C25.7448 22.7186 26.1018 22.8654 26.2309 23.1742L27.6309 26.5413C28.4512 28.511 30.717 29.4451 32.6866 28.6249C32.9955 28.4958 33.3524 28.6426 33.4815 28.9515C33.6107 29.2603 33.4638 29.6173 33.155 29.7464C32.517 30.0122 31.8562 30.1388 31.2081 30.1388Z'
      fill='black'
    />
    <path
      d='M24.3072 18.6915C24.0692 18.6915 23.8439 18.5497 23.7451 18.3168C23.616 18.0079 23.7628 17.651 24.0717 17.5218L34.0413 13.375C34.3502 13.2459 34.7072 13.3927 34.8363 13.7016C34.9654 14.0105 34.8185 14.3674 34.5097 14.4965L24.5401 18.6434C24.4641 18.6763 24.3856 18.6915 24.3072 18.6915Z'
      fill='black'
    />
  </svg>
);
const ArrowBlue = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 8L13 8M13 8L8.5 3.5M13 8L8.5 12.5'
      stroke='#195D9D'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const FourCircles = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.0003 2.85712C10.0003 2.85712 17.1431 2.85712 17.1431 9.99997C17.1431 9.99997 17.1431 17.1428 10.0003 17.1428C10.0003 17.1428 2.85742 17.1428 2.85742 9.99997C2.85742 9.99997 2.85742 2.85712 10.0003 2.85712Z'
      stroke='#195D9D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M30.0003 2.85712C30.0003 2.85712 37.1431 2.85712 37.1431 9.99997C37.1431 9.99997 37.1431 17.1428 30.0003 17.1428C30.0003 17.1428 22.8574 17.1428 22.8574 9.99997C22.8574 9.99997 22.8574 2.85712 30.0003 2.85712Z'
      stroke='#41C7A2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.0003 22.8571C10.0003 22.8571 17.1431 22.8571 17.1431 30C17.1431 30 17.1431 37.1428 10.0003 37.1428C10.0003 37.1428 2.85742 37.1428 2.85742 30C2.85742 30 2.85742 22.8571 10.0003 22.8571Z'
      stroke='#41C7A2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M30.0003 22.8571C30.0003 22.8571 37.1431 22.8571 37.1431 30C37.1431 30 37.1431 37.1428 30.0003 37.1428C30.0003 37.1428 22.8574 37.1428 22.8574 30C22.8574 30 22.8574 22.8571 30.0003 22.8571Z'
      stroke='#195D9D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const WellBeing = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.85742 12.8571H7.14314L11.4288 22.8571L21.4288 2.85712L27.1431 14.2857'
      stroke='#195D9D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27.858 37.1428L20.0339 29.8925C15.6525 25.6154 21.9639 17.3219 27.858 23.9984C33.752 17.3219 40.0634 25.6154 35.682 29.8925L27.858 37.1428Z'
      stroke='#41C7A2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const StreamLine = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_24809_5570)'>
      <path
        d='M1.42773 20C1.42773 24.9254 3.38436 29.6492 6.86718 33.132C10.35 36.6148 15.0737 38.5714 19.9992 38.5714C24.9246 38.5714 29.6483 36.6148 33.1311 33.132C36.614 29.6492 38.5706 24.9254 38.5706 20C38.5706 15.0745 36.614 10.3508 33.1311 6.868C29.6483 3.38519 24.9246 1.42856 19.9992 1.42856C15.0737 1.42856 10.35 3.38519 6.86718 6.868C3.38436 10.3508 1.42773 15.0745 1.42773 20Z'
        stroke='#195D9D'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.7129 11.4286C15.7129 11.9914 15.8237 12.5487 16.0391 13.0686C16.2545 13.5886 16.5702 14.0611 16.9681 14.459C17.3661 14.857 17.8386 15.1727 18.3585 15.3881C18.8785 15.6034 19.4358 15.7143 19.9986 15.7143C20.5614 15.7143 21.1187 15.6034 21.6387 15.3881C22.1586 15.1727 22.6311 14.857 23.0291 14.459C23.427 14.0611 23.7427 13.5886 23.9581 13.0686C24.1735 12.5487 24.2843 11.9914 24.2843 11.4286C24.2843 10.8658 24.1735 10.3085 23.9581 9.7885C23.7427 9.26853 23.427 8.79607 23.0291 8.39811C22.6311 8.00014 22.1586 7.68446 21.6387 7.46908C21.1187 7.25371 20.5614 7.14285 19.9986 7.14285C19.4358 7.14285 18.8785 7.25371 18.3585 7.46908C17.8386 7.68446 17.3661 8.00014 16.9681 8.39811C16.5702 8.79607 16.2545 9.26853 16.0391 9.7885C15.8237 10.3085 15.7129 10.8658 15.7129 11.4286Z'
        stroke='#41C7A2'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.7137 25V21.4285C25.7137 18.2726 23.1554 15.7143 19.9994 15.7143C16.8435 15.7143 14.2852 18.2726 14.2852 21.4285V25H16.428L17.1423 32.8571H22.8566L23.5709 25H25.7137Z'
        stroke='#41C7A2'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_24809_5570'>
        <rect width='40' height='40' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
const GreenCheckSquare = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.1333 17.6L19.5333 8.2L17.6667 6.33333L10.1333 13.8667L6.33333 10.0667L4.46667 11.9333L10.1333 17.6ZM2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM2.66667 21.3333H21.3333V2.66667H2.66667V21.3333Z'
        fill='#208260'
      />
    </svg>
  );
};
const WhiteArrow = ({ width = 26, height = 31 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 26 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25.4142 16.9142C26.1953 16.1332 26.1953 14.8668 25.4142 14.0858L12.6863 1.35786C11.9052 0.576816 10.6389 0.576816 9.85786 1.35786C9.07682 2.13891 9.07682 3.40524 9.85786 4.18629L21.1716 15.5L9.85786 26.8137C9.07682 27.5948 9.07682 28.8611 9.85786 29.6421C10.6389 30.4232 11.9052 30.4232 12.6863 29.6421L25.4142 16.9142ZM0 15.5V17.5H24V15.5V13.5H0V15.5Z'
        fill='white'
      />
    </svg>
  );
};
const ChevronRight = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 18L15 12L9 6'
        stroke='#121212'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const CrossIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 4L4 12'
        stroke='#151515'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 4L12 12'
        stroke='#151515'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const BlueCheckMark = ({
  width = '24',
  height = '24',
  color = 'none',
  stroke = '#195D9D',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M8 12.5C8 12.5 9.5 12.5 11.5 16C11.5 16 17.0588 6.83333 22 5'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const theDashedLines = ({ stroke = '#141B34' }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 12H4.5M7.5 12H10M13 12H15.5M18.5 12H21'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const ArrowBlackLong = () => {
  return (
    <svg
      width='17'
      height='15'
      viewBox='0 0 17 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.7071 8.07112C17.0976 7.6806 17.0976 7.04743 16.7071 6.65691L10.3431 0.292946C9.95262 -0.0975785 9.31946 -0.0975785 8.92893 0.292946C8.53841 0.68347 8.53841 1.31664 8.92893 1.70716L14.5858 7.36401L8.92893 13.0209C8.53841 13.4114 8.53841 14.0446 8.92893 14.4351C9.31946 14.8256 9.95262 14.8256 10.3431 14.4351L16.7071 8.07112ZM0 7.36401V8.36401H16V7.36401V6.36401H0V7.36401Z'
        fill='#1E1E1E'
      />
    </svg>
  );
};
const GreenCheckRound = ({ width = 24, height = 24, color = '#208260' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 12.5C8 12.5 10 13 11.5 16C11.5 16 17.0588 6.83333 22 5'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const ArrowBlackLongLeft = () => {
  return (
    <svg
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.338313 8.02815C-0.120825 8.49877 -0.111524 9.25248 0.359087 9.71161L8.02814 17.1937C8.49875 17.6528 9.25246 17.6435 9.7116 17.1729C10.1707 16.7023 10.1614 15.9486 9.69083 15.4895L2.87389 8.83872L9.52463 2.02179C9.98376 1.55117 9.97446 0.797464 9.50385 0.338326C9.03324 -0.120811 8.27953 -0.11151 7.82039 0.359101L0.338313 8.02815ZM1.19043 8.8595L1.20512 10.0499L18.6967 9.83403L18.682 8.64364L18.6673 7.45326L1.17574 7.66911L1.19043 8.8595Z'
        fill='#1E1E1E'
      />
    </svg>
  );
};
const DollarIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_27825_7587)'>
        <path
          d='M16 28C12.7947 28 9.78119 26.7518 7.51469 24.4853C5.24819 22.2188 4 19.2053 4 16C4 12.7947 5.24823 9.78123 7.51469 7.51469C9.78114 5.24814 12.7947 4 16 4C19.2053 4 22.2188 5.24819 24.4853 7.51469C26.7518 9.78119 28 12.7947 28 16C28 19.2053 26.7518 22.2188 24.4853 24.4853C22.2189 26.7519 19.2053 28 16 28ZM16 5.5C10.2103 5.5 5.5 10.2103 5.5 16C5.5 21.7897 10.2103 26.5 16 26.5C21.7897 26.5 26.5 21.7897 26.5 16C26.5 10.2103 21.7897 5.5 16 5.5Z'
          fill='#1F6BB3'
        />
        <path
          d='M16 15.25C14.9661 15.25 14.125 14.4089 14.125 13.375C14.125 12.3411 14.9661 11.5 16 11.5C17.0339 11.5 17.875 12.3411 17.875 13.375C17.875 13.7892 18.2108 14.125 18.625 14.125C19.0392 14.125 19.375 13.7892 19.375 13.375C19.375 11.7718 18.251 10.4271 16.75 10.085V9.25C16.75 8.83581 16.4142 8.5 16 8.5C15.5858 8.5 15.25 8.83581 15.25 9.25V10.085C13.749 10.4271 12.625 11.7718 12.625 13.375C12.625 15.236 14.139 16.75 16 16.75C17.0339 16.75 17.875 17.5911 17.875 18.625C17.875 19.6589 17.0339 20.5 16 20.5C14.9661 20.5 14.125 19.6589 14.125 18.625C14.125 18.2108 13.7892 17.875 13.375 17.875C12.9608 17.875 12.625 18.2108 12.625 18.625C12.625 20.2282 13.749 21.5729 15.25 21.915V22.75C15.25 23.1642 15.5858 23.5 16 23.5C16.4142 23.5 16.75 23.1642 16.75 22.75V21.915C18.251 21.5729 19.375 20.2282 19.375 18.625C19.375 16.764 17.861 15.25 16 15.25Z'
          fill='#1F6BB3'
        />
      </g>
      <defs>
        <clipPath id='clip0_27825_7587'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(4 4)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const GradientCheck = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 13L9 17L19 7'
        stroke='url(#paint0_linear_27307_9053)'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_27307_9053'
          x1='5'
          y1='12'
          x2='19'
          y2='12'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#1F6BB3' />
          <stop offset='1' stopColor='#49D1AB' />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ArrowWhiteShort = ({
  width = 17,
  height = 15,
  color = 'none',
  stroke = '#fff',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 15'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.7071 8.07039C17.0976 7.67986 17.0976 7.0467 16.7071 6.65617L10.3431 0.292213C9.95262 -0.0983109 9.31946 -0.0983109 8.92893 0.292213C8.53841 0.682738 8.53841 1.3159 8.92893 1.70643L14.5858 7.36328L8.92893 13.0201C8.53841 13.4107 8.53841 14.0438 8.92893 14.4343C9.31946 14.8249 9.95262 14.8249 10.3431 14.4343L16.7071 8.07039ZM0 7.36328V8.36328H16V7.36328V6.36328H0V7.36328Z'
        fill={stroke}
      />
    </svg>
  );
};
const SearchButton = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='32' height='32' rx='16' fill='#1E1E1E' />
      <path
        d='M22.9952 22.9952L19.6149 19.6149M21.4411 15.2244C21.4411 18.6578 18.6578 21.4411 15.2244 21.4411C11.7911 21.4411 9.00781 18.6578 9.00781 15.2244C9.00781 11.7911 11.7911 9.00781 15.2244 9.00781C18.6578 9.00781 21.4411 11.7911 21.4411 15.2244Z'
        stroke='white'
        strokeWidth='1.14183'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
const CaretUp = ({
  width = 24,
  height = 24,
  color = 'none',
  stroke = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 15C18 15 13.581 9.00001 11.9999 9C10.4188 8.99999 6 15 6 15'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

const CaretRight = ({
  width = 20,
  height = 20,
  color = 'none',
  stroke = '#1E1E1E',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.50004 5C7.50004 5 12.5 8.68242 12.5 10C12.5 11.3177 7.5 15 7.5 15'
        stroke={stroke}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export {
  CaretUp,
  CaretRight,
  SearchButton,
  ArrowWhiteShort,
  GradientCheck,
  DollarIcon,
  CheckMarkIcon,
  ArrowBlackLongLeft,
  GreenCheckRound,
  ArrowBlackLong,
  theDashedLines,
  BlueCheckMark,
  CrossIcon,
  ChevronRight,
  GreenCheckSquare,
  WhiteArrow,
  StreamLine,
  WellBeing,
  FourCircles,
  ArrowBlue,
  Pills,
  NurseCap,
  PatientSupport,
  Auth,
  DocNote,
  DiscountBadge,
  GreenBgTick,
  ArrowRightBlack,
  SearchFilter,
  WhiteArrowDiagonal,
  ArrowRightLong,
  TheI,
  NoteIcon,
  ZapIcon,
  TimerIcon,
  ArrowLocation,
  LogoutIcon,
  WhiteCheckMark,
  DashboardIcon,
  MenuUserIcon,
  PersonIcon,
  TickerIcon1,
  TickerIcon2,
  TickerIcon3,
  TickerIcon4,
  TickerIcon5,
  ArrowRight,
  Hamburger,
  CloseIcon,
  UserIcon,
  ArrowDown,
  ArrowUp,
  CheckMark,
  SearchIcon,
  Treatment,
  Dosage,
  Lisence,
  Shipping,
  Fees,
  OnlineCare,
  Secure,
  Insurance,
  Heart,
  CheckVerified,
  CheckHero,
  CheckService,
  ArrowWhite,
  CheckTable,
  ArrowGreen,
  UrgentCare,
  WeightLoss,
  SexualHealth,
  AllConditions,
  ArrowRightWhite,
  ArrowLeft,
  ArrowRightBg,
  PrescriptionCheck,
  BlackBolt,
  GreenTick,
  RedCross,
  BoltWhite,
  ArrowWhiteSmall,
  ArrowRightShort,
};
